<template>
  <div class="container fixed-header-container"
       :class="{'with-banner': showBetaBanner && !bannerHidden, 'fixed-header-container-padding': this.isLoggedIn}"
       id="app">
      <head>
        <title v-if="course.id">{{course.name}}</title>
        <title v-else>Event</title>
      </head>
    <template v-if="corporation">
      <play-aloud-text v-if="corporation.accessibility_on"></play-aloud-text>
      <!-- Common components -->
      <course-enroll-modal :requisites="requisites"
                           :course-id="enrollCourseID"
                           :show-dialog="openEnroll">
      </course-enroll-modal>
   
      <!-- <wait-list-modal
      				         :id-course="waitListCourseID"
                       :seat-selected="seatSelected"                       
                       :value="openDialogProp"
                       @refresh="refresh"
                       :message="waitlistMessage">
      </wait-list-modal> -->
    

      <wait-list-remove-modal v-model="openWaitListRemoveModal"
      :id-course="waitListCourseID"
                       @changeWaitlist="changeWaitlist"
                       :seat_name="course.course_name"
                       :custom_waitlist="custom_waitlist"
                       >
      </wait-list-remove-modal>

      <md-dialog :md-active.sync="showAddedFavoritesModal" class="added-to-favorites-modal">
        <div class="modal-content p-3">
          <div class="modal-body p-3">
              <div class="row">
                <div class="col-12">
                  <h1 class="mb-0">{{ t('Add to Favorites') }}</h1>
                  <button type="button" class="close mb-0" @click="closeAddedFavoritesModal()" data-dismiss="modal" aria-label="Close">
                    <CloseIcon />
                  </button>
                </div>
                <div class="col-12"><h1 class="mb-0">&nbsp;</h1></div>
                <div class="col-12">
                  <div class="img-fluid-container px-2 pb-3">
                    <img v-if="course.course_image_body" loading="lazy" :src="`/index.php?r=course/getFile&courseid=${course.id_course}&file=${course.course_image_body}`" class="img-fluid rounded" />
                    <canvas v-else class="img-fluid rounded" :style="`background-image: linear-gradient(to right, ${getRandomRgb()}, ${getRandomRgb()})`"></canvas>
                  </div>
                </div>
                <div class="col-12">
                  <div class="px-2"><p class="mb-5 text-center">{{ t('The event') }}&nbsp;<strong>{{ course.name }}</strong>&nbsp;{{ t('was added to Favorites') }}</p></div>
                </div>
                <div class="col-12"><div class="px-2"><hr class="my-3" style="border-top-color: rgb(151,151,151);" /></div></div>
                <div class="col-12">
                  <div class="px-2">
                    <div class="d-flex justify-content-between">
                        <button type="button" class="btn btn-outline-primary waves-effect waves-themed" @click="goToFavorites()">{{ t('Go to Favorites') }}</button>
                        <button type="button" class="btn btn-primary waves-effect waves-themed" @click="seeMoreEvents()">{{ t('See more events') }}</button>
                    </div>
                  </div>
                </div>
              </div><!-- .row -->
          </div><!-- .modal-body -->
        </div><!-- .modal-content -->
      </md-dialog>
      <md-dialog :md-active.sync="showUnfollowModal">
        <div class="modal-content">
          <div class="modal-body p-5">
            <div class="d-flex justify-content-center mb-4"><TimeAlmostOutIcon /></div>
            <h4 class="font-weight-bold text-center mb-4">{{ t('A confirmation is required') }}</h4>
            <p class="text-center mb-4">{{ t('Do you want to unfollow the path ') }} {{ course.course_name }}{{ t('?') }}</p>
            <div class="d-flex justify-content-between">
              <button type="button" class="btn btn-outline-primary waves-effect waves-themed" @click="showUnfollowModal = false">{{ t('Cancel') }}</button>
              <button type="button" class="btn btn-primary waves-effect waves-themed" @click="doUnfollowPath">{{ t('Yes, unfollowed') }}</button>
            </div>
          </div>
        </div>
      </md-dialog>

      <md-dialog :md-active.sync="showfollowModal">
        <div class="modal-content">
          <div class="modal-body p-5">
            <div class="d-flex justify-content-center mb-4"><ArtWorking /></div>
            <h4 class="font-weight-bold text-center mb-4">{{ t('You are now following the path') }}</h4>
            <p class="text-center mb-4">{{ course.course_name }}&nbsp;{{ t('is in your My Events list.') }}</p>
            <div class="d-flex justify-content-between">
              <button type="button" class="btn btn-outline-primary waves-effect waves-themed" @click="showfollowModal = false">{{ t('Cancel') }}</button>
              <button type="button" class="btn btn-primary waves-effect waves-themed" @click="followPath">{{ t('Yes') }}</button>
            </div>
          </div>
        </div>
      </md-dialog>

      <login-modal :corporation="corporation"
                   :modal-view="sessionModalView"
                   @change-view="sessionModalView = $event"
                   @refresh-session="stayAlive()"
                   :show-dialog="openLogin">
      </login-modal>
      <main-header @open-login="openLoginDialog()"
                   @hide-banner="hideBanner()"
                   :show-banner="showBetaBanner"
                   :banner-hidden="bannerHidden"

                   :catalogues="corporation.catalogues"
                   @open-signup="openSignUpDialog()"

                   >
      </main-header>
      <!-- End common components -->
      <template v-if="!courseLoaded">
        <div class="container py-5"><div class="container py-5">&nbsp;</div></div>
      </template>
      <template v-else-if="isApplication">
        <!-- Modal seat block -->
      <md-dialog
        :md-active.sync="applyAppModal"
        :md-click-outside-to-close="false"
        class="modal-apply-application">
        <div class="modal-content">
          <div class="modal-body p-4">
            <div class="app-info d-flex flex-column">
              <div class="d-flex justify-content-end pb-3"><CloseIcon :color="applyingApp ? '#ABABAB' : '#256AB3'" @click.native="if(!applyingApp) { applyAppModal = false; }" style="cursor: pointer" /></div>
              <div class="d-flex justify-content-center pb-4 pt-3"><ClickIcon v-if="course.id_applied" /><SeatComputerIcon v-else /></div>
              <h1 class="px-4">{{ course.id_applied ? t('You have one application open or in progress') : t('Are you ready to start your application?') }}</h1>
              <p v-if="course.id_applied" class="text-center mb-4">{{ t('Go to My applications for details on the status.') }}</p>
            </div>
            <div class="app-actions">
              <button @click="if(course.id_applied) { tryNewApplication = true; startApplication(); } else if(!applyingApp) { applyAppModal = false; }" type="button" class="btn btn-app-cancel" :class="{ disabled: applyingApp }">{{ course.id_applied ? t('Try new application') : t('Cancel') }}</button>
              <button @click="startApplication" class="btn btn-app-apply" :class="{ disabled: applyingApp, }">{{ course.id_applied ? t('Go to My applications') : t('Start Application') }}</button>
            </div>
          </div>
        </div>
      </md-dialog>
      <!-- Modal seat block -->
        <section class="app-section container pt-4 pb-0">
          <div class="course-breadcrumb mt-2 app-mb">
            <ol class="breadcrumb d-none d-sm-flex my-0">
              <li v-for="item in course.breadcrumb" v-bind:key="item" class="breadcrumb-item">
                <a :href="item.url"
                  :style="{color: _.get(corporation, 'color_filters', null) }">
                  {{translateHome(item.text)}}
                </a>
              </li>
              <li class="breadcrumb-item active">{{ course.name }} | {{ t('Application') }}</li>
            </ol>
          </div>

          <div class="container-fluid">
            <div class="row">
              <div class="col-12">
                <div class="app-header">
                  <HeartReactionIcon :course="course" />
                  <h1 class="app-title">{{ course.name }}</h1>
                </div>
                <div class="app-header">
                  <span>&nbsp;</span>
                  <p class="app-subtitle app-mb"><span class="app-type mr-4">{{ t('Application') }}</span> <span v-if="showStartDate" class="app-available">{{ t('Available:') }}&nbsp;{{ t('From') }}&nbsp;{{ course.course_start_date | formatAppDate }}<span v-if="showEndDate">&nbsp;{{ t('to') }}&nbsp;{{ course.course_end_date | formatAppDate }}</span></span> </p>
                </div>
              </div>

              <div class="col-12 app-image">
                <course-images-carousel v-if="hasImages" :comments="course.carousel"
                                    :show-review="true">
                </course-images-carousel>
                <canvas v-else class="img-fluid rounded" :style="`background-image: linear-gradient(to right, ${getRandomRgb()}, ${getRandomRgb()})`"></canvas>
              </div>
              <div class="col-12">
                <div class="app-info-title">
                  <RegistrationIcon />
                  <p>{{ t('Application Information') }}</p>
                </div>
              </div>
              <div class="col-12 app-description" v-html="$sanitize(course.description)"></div>
              <div class="col-12">
                <button class="app-btn" :class="{ disabled: validatingApplied, }" @click="openStartApplication">{{ t('Start your application') }}</button>
              </div>
              <!-- if course.share_with_friends dynamic needed -->
              <div v-if="corporationInfo.shareFacebook || corporationInfo.shareX || corporationInfo.shareEmail" class="col-12 app-share">
                {{ t('Share') }}
                <div class="social-media">
                    <a v-if="corporationInfo.shareFacebook" href="javascript:void(0)" @click="shareFB"><FacebookSimple /></a>
                    <a v-if="corporationInfo.shareX" href="javascript:void(0)" @click="shareTR"><twitterXIcon :height="32" :width="32" :iconColor="'#fff'" /></a>
                    <a v-if="corporationInfo.shareEmail" :href="emailHref"><EnvelopeSimple /></a>
                </div>
              </div>
               <!-- <div class="col-12 app-carousel">
                <p class="app-carousel-hdr font-weight-bold">{{ t('You may also like') }}</p>
                <CoursesSlider v-if="showImagesSlider"
                        :corporation="corporation"
                        @enroll="enroll"
                        @wait-list="addToWaitList"
                        :courses-list="courses" />
              </div>-->
            </div>
          </div>
        </section>
      </template>
      <template v-else-if="isPerformancePlan">
        <!-- Performance Plan Modal -->
        <md-dialog
          :md-active.sync="performancePlanModal"
          :md-click-outside-to-close="false"
          class="modal-apply-application">
          <div class="modal-content">
            <div class="modal-body p-4">
              <div class="app-info d-flex flex-column">
                <div class="d-flex justify-content-end pb-3">
                  <CloseIcon :color="startingPlan ? '#ABABAB' : '#256AB3'" @click.native="if(!startingPlan) { performancePlanModal = false; }" style="cursor: pointer" />
                </div>
                <div class="d-flex justify-content-center pb-4 pt-3">
                  <SeatComputerIcon />
                </div>
                <h1 class="px-4">{{ myPerformancePlans.length > 0 ? t('You have existing performance plans') : t('Start your Performance Plan') }}</h1>
                <p v-if="myPerformancePlans.length > 0" class="text-center mb-4">{{ t('Continue an existing plan or start a new one for the current year.') }}</p>
              </div>
              <div v-if="myPerformancePlans.length > 0" class="existing-plans-list px-4 pb-3">
                <div v-for="plan in myPerformancePlans" :key="plan.id_plan" class="existing-plan-item d-flex justify-content-between align-items-center py-2 border-bottom">
                  <div>
                    <strong>{{ plan.plan_year }}</strong>
                    <span class="ml-2 badge" :class="{
                      'badge-info': plan.current_stage === 'PLANNING',
                      'badge-warning': plan.current_stage === 'INTERIM',
                      'badge-primary': plan.current_stage === 'YEAR_END',
                      'badge-success': plan.current_stage === 'COMPLETED'
                    }">{{ plan.current_stage }}</span>
                  </div>
                  <button @click="continuePlan(plan)" class="btn btn-sm btn-outline-primary">{{ t('Continue') }}</button>
                </div>
              </div>
              <div class="app-actions">
                <button @click="performancePlanModal = false" type="button" class="btn btn-app-cancel" :class="{ disabled: startingPlan }">{{ t('Cancel') }}</button>
                <button @click="startNewPlan" class="btn btn-app-apply" :class="{ disabled: startingPlan }">
                  {{ myPerformancePlans.length > 0 ? t('Start New Plan for ') + currentYear : t('Start Plan') }}
                </button>
              </div>
            </div>
          </div>
        </md-dialog>
        <!-- Performance Plan Section -->
        <section class="app-section container pt-4 pb-0">
          <div class="course-breadcrumb mt-2 app-mb">
            <ol class="breadcrumb d-none d-sm-flex my-0">
              <li v-for="item in course.breadcrumb" v-bind:key="item" class="breadcrumb-item">
                <a :href="item.url" :style="{color: _.get(corporation, 'color_filters', null) }">
                  {{ translateHome(item.text) }}
                </a>
              </li>
              <li class="breadcrumb-item active">{{ course.name }} | {{ t('Performance Plan') }}</li>
            </ol>
          </div>

          <div class="container-fluid">
            <div class="row">
              <div class="col-12">
                <div class="app-header">
                  <HeartReactionIcon :course="course" />
                  <h1 class="app-title">{{ course.name }}</h1>
                </div>
                <div class="app-header">
                  <span>&nbsp;</span>
                  <p class="app-subtitle app-mb">
                    <span class="app-type mr-4">{{ t('Performance Plan') }}</span>
                    <span v-if="course.plan_type" class="badge badge-primary mr-2">{{ course.plan_type }}</span>
                  </p>
                </div>
              </div>

              <div class="col-12 app-image">
                <course-images-carousel v-if="hasImages" :comments="course.carousel" :show-review="true"></course-images-carousel>
                <canvas v-else class="img-fluid rounded" :style="`background-image: linear-gradient(to right, ${getRandomRgb()}, ${getRandomRgb()})`"></canvas>
              </div>

              <div class="col-12">
                <div class="app-info-title">
                  <RegistrationIcon />
                  <p>{{ t('Performance Plan Information') }}</p>
                </div>
              </div>
              <div class="col-12 app-description" v-html="$sanitize(course.description)"></div>

              <!-- Existing Plans Summary -->
              <div v-if="myPerformancePlans.length > 0" class="col-12 mb-4">
                <div class="card">
                  <div class="card-header bg-light">
                    <strong>{{ t('Your Performance Plans') }}</strong>
                  </div>
                  <div class="card-body p-0">
                    <div v-for="plan in myPerformancePlans" :key="plan.id_plan"
                         class="d-flex justify-content-between align-items-center p-3 border-bottom">
                      <div>
                        <strong>{{ plan.plan_year }}</strong>
                        <span class="ml-2 badge" :class="{
                          'badge-info': plan.current_stage === 'PLANNING',
                          'badge-warning': plan.current_stage === 'INTERIM',
                          'badge-primary': plan.current_stage === 'YEAR_END',
                          'badge-success': plan.current_stage === 'COMPLETED'
                        }">{{ plan.current_stage }}</span>
                        <small v-if="plan.supervisor_name" class="ml-2 text-muted">
                          {{ t('Supervisor') }}: {{ plan.supervisor_name }} {{ plan.supervisor_lastname }}
                        </small>
                      </div>
                      <button @click="continuePlan(plan)" class="btn btn-primary btn-sm">
                        {{ plan.current_stage === 'COMPLETED' ? t('View') : t('Continue') }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <button class="app-btn" :class="{ disabled: loadingMyPlans }" @click="openStartPlanModal">
                  {{ myPerformancePlans.length > 0 ? t('Start New Plan for ') + currentYear : t('Start your Performance Plan') }}
                </button>
              </div>

              <!-- Share section -->
              <div v-if="corporationInfo.shareFacebook || corporationInfo.shareX || corporationInfo.shareEmail" class="col-12 app-share">
                {{ t('Share') }}
                <div class="social-media">
                  <a v-if="corporationInfo.shareFacebook" href="javascript:void(0)" @click="shareFB"><FacebookSimple /></a>
                  <a v-if="corporationInfo.shareX" href="javascript:void(0)" @click="shareTR"><twitterXIcon :height="32" :width="32" :iconColor="'#fff'" /></a>
                  <a v-if="corporationInfo.shareEmail" :href="emailHref"><EnvelopeSimple /></a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </template>
      <template v-else-if="!showCourse"><!-- SHOW COURSE CONTENT -->
          <div class="row">
            <div class="col-12 text-center pb-4 pt-3">
              <div class="col-12 pb-3 pt-4 d-none d-sm-block">
                <svg width="312" height="238" viewBox="0 0 312 238" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <defs>
                        <linearGradient id="l" y1="38.919%" y2="61.526%">
                            <stop stop-color="#FBED96" offset="0"/>
                            <stop stop-color="#ABECD6" offset="1"/>
                        </linearGradient>
                        <linearGradient id="k" x1="81.275%" x2="50%" y1="38.903%" y2="72.547%">
                            <stop stop-color="#FFF" stop-opacity=".5" offset="0"/>
                            <stop stop-opacity=".5" offset="1"/>
                        </linearGradient>
                        <path id="h" d="M95.39 16.035c.621.157 1.233.348 1.833.57l27.004 10.019c12.02-4.747 25.226-7.352 39.127-7.352 40.64 0 75.769 22.912 92.436 56.16l16.443 6.104c10.538 3.91 16.434 15.135 13.673 26.03l-.051.202c-2.397 9.455-11.891 15.235-21.35 13.09-1.855.733-4.734 1.32-5.263 6.68-.704 7.14 4.431 6.42 5.251 7.998l15.684 5.356c9.055 3.091 13.89 12.938 10.798 21.992l-.02.06c-3.14 9.086-13.035 13.922-22.133 10.817l-16.075-5.489-.133.228c-1.47 2.495-6.465-4.114-11.251 4.2-4.787 8.314 3.226 7.51 1.441 9.62l-.145.171c6.343 4.11 9.528 11.99 7.4 19.592-2.392 8.55-11.262 13.54-19.81 11.149a16.074 16.074 0 01-.729-.223l-17.806-5.905c-14.413 7.48-30.876 11.72-48.36 11.72-41.721 0-77.635-24.147-93.727-58.836l-22.419-7.436c-8.955-2.97-13.998-12.45-11.456-21.536 2.392-8.55 11.262-13.54 19.81-11.149.245.069.488.143.729.223l4.331 1.436c.002-.178.005-.33.01-.197l.003.095.008-.052c.346-2.075 4.715 1.358 6.886-6.766l.09-.345c2.017-8.085-4.15-9.026-5.039-10.91l-17.81-6.08c-9.055-3.092-13.89-12.939-10.798-21.993l.02-.06c3.139-9.086 13.035-13.922 22.132-10.817l17.985 6.14c2.538-.864 7.86 3.918 12.113-3.21 4.618-7.744-2.161-10.643-1.13-13-9.19-4.547-14.119-14.972-11.549-25.112l.051-.202c2.434-9.604 12.193-15.416 21.796-12.982zm211.767 138.361c5.119 1.566 7.662 8.812 5.68 16.184-1.981 7.372-7.737 12.079-12.855 10.513-5.118-1.566-7.662-8.812-5.68-16.184 1.981-7.372 7.737-12.079 12.855-10.513zM24.591 56.31c5.119 1.566 7.543 9.255 5.415 17.173-2.129 7.918-8.003 13.068-13.121 11.502-5.119-1.566-7.543-9.254-5.415-17.173 2.128-7.918 8.003-13.068 13.121-11.502z"/>
                        <path id="i" d="M0 0h82.386v158.144H0z"/>
                    </defs>
                    <g fill="none" fill-rule="evenodd">
                        <g transform="translate(-6 15.152)">
                            <mask id="j" fill="#fff">
                                <use xlink:href="#h"/>
                            </mask>
                            <g transform="rotate(-6 162.1 117.15)" opacity=".406">
                                <use fill="url(#l)" xlink:href="#h"/>
                                <use fill="url(#k)" fill-opacity=".1" xlink:href="#h"/>
                            </g>
                            <g mask="url(#j)">
                                <g transform="translate(117.42 43.56)">
                                    <mask id="g" fill="#fff">
                                        <use xlink:href="#i"/>
                                    </mask>
                                    <use fill="#103746" xlink:href="#i"/>
                                    <g mask="url(#g)">
                                        <g transform="translate(13.258 71.023)">
                                            <ellipse cx="20.265" cy="20.07" rx="20.265" ry="20.07" fill="#269CCB"/>
                                            <path d="M31.157 28.59c1.362 0 2.467 1.08 2.467 2.414 0 .146-.019.287-.044.426.407-.43.66-1.001.66-1.634 0-1.333-1.104-2.414-2.466-2.414-1.214 0-2.217.86-2.424 1.988.451-.477 1.09-.78 1.807-.78zM4.602 21.968c1.362 0 2.467 1.08 2.467 2.414 0 .146-.019.288-.044.427.406-.431.66-1.002.66-1.634 0-1.333-1.104-2.414-2.467-2.414-1.213 0-2.216.859-2.423 1.987.45-.477 1.09-.78 1.807-.78zm12.259 7.738a4.032 4.032 0 00-3.528 2.06l.131.252a4.048 4.048 0 012.777-1.098c2.226 0 4.03 1.765 4.03 3.944 0 .39-.06.766-.168 1.122.493-.654.788-1.46.788-2.336 0-2.179-1.804-3.944-4.03-3.944zM33.268 16.185c1.356 0 2.455 1.05 2.455 2.343 0 .142-.018.28-.043.415.404-.419.657-.972.657-1.586 0-1.294-1.1-2.343-2.455-2.343-1.207 0-2.206.833-2.411 1.929a2.496 2.496 0 011.797-.758zm-16.176 2.511c1.356 0 2.455 1.05 2.455 2.344 0 .141-.019.279-.044.414.405-.419.658-.972.658-1.586 0-1.294-1.1-2.343-2.455-2.343-1.208 0-2.206.833-2.412 1.929a2.496 2.496 0 011.798-.758zm-8.306-7.049c1.355 0 2.454 1.05 2.454 2.343 0 .142-.018.28-.043.415.404-.419.657-.972.657-1.586 0-1.294-1.099-2.343-2.455-2.343-1.207 0-2.206.833-2.411 1.929a2.496 2.496 0 011.798-.758zm12.889-6.803a4.03 4.03 0 00-3.51 2l.13.244a4.083 4.083 0 012.763-1.066c2.215 0 4.01 1.714 4.01 3.829 0 .378-.06.744-.167 1.089.49-.635.785-1.418.785-2.267 0-2.115-1.796-3.829-4.011-3.829z" fill="#1483A8" fill-rule="nonzero"/>
                                        </g>
                                    </g>
                                    <g mask="url(#g)">
                                        <g transform="translate(49.242 15.152)">
                                            <ellipse cx="20.265" cy="20.07" rx="20.265" ry="20.07" fill="#7334AA"/>
                                            <path d="M31.157 28.59c1.362 0 2.467 1.08 2.467 2.414 0 .146-.019.287-.044.426.407-.43.66-1.001.66-1.634 0-1.333-1.104-2.414-2.466-2.414-1.214 0-2.217.86-2.424 1.988.451-.477 1.09-.78 1.807-.78zM4.602 21.968c1.362 0 2.467 1.08 2.467 2.414 0 .146-.019.288-.044.427.406-.431.66-1.002.66-1.634 0-1.333-1.104-2.414-2.467-2.414-1.213 0-2.216.859-2.423 1.987.45-.477 1.09-.78 1.807-.78zm12.259 7.738a4.032 4.032 0 00-3.528 2.06l.131.252a4.048 4.048 0 012.777-1.098c2.226 0 4.03 1.765 4.03 3.944 0 .39-.06.766-.168 1.122.493-.654.788-1.46.788-2.336 0-2.179-1.804-3.944-4.03-3.944zM33.268 16.185c1.356 0 2.455 1.05 2.455 2.343 0 .142-.018.28-.043.415.404-.419.657-.972.657-1.586 0-1.294-1.1-2.343-2.455-2.343-1.207 0-2.206.833-2.411 1.929a2.496 2.496 0 011.797-.758zm-16.176 2.511c1.356 0 2.455 1.05 2.455 2.344 0 .141-.019.279-.044.414.405-.419.658-.972.658-1.586 0-1.294-1.1-2.343-2.455-2.343-1.208 0-2.206.833-2.412 1.929a2.496 2.496 0 011.798-.758zm-8.306-7.049c1.355 0 2.454 1.05 2.454 2.343 0 .142-.018.28-.043.415.404-.419.657-.972.657-1.586 0-1.294-1.099-2.343-2.455-2.343-1.207 0-2.206.833-2.411 1.929a2.496 2.496 0 011.798-.758zm12.889-6.803a4.03 4.03 0 00-3.51 2l.13.244a4.083 4.083 0 012.763-1.066c2.215 0 4.01 1.714 4.01 3.829 0 .378-.06.744-.167 1.089.49-.635.785-1.418.785-2.267 0-2.115-1.796-3.829-4.011-3.829z" fill="#3F0770" fill-rule="nonzero"/>
                                        </g>
                                    </g>
                                    <path d="M33.682 37.879c-.352 3.098-2.11 4.82-5.273 5.165 3.164.344 4.921 2.067 5.273 5.165.351-3.098 2.11-4.82 5.273-5.165-3.164-.345-4.922-2.067-5.273-5.165zM70.24 66.804c-.305 2.685-1.827 4.178-4.57 4.477 2.743.298 4.265 1.79 4.57 4.477.305-2.686 1.828-4.179 4.57-4.477-2.742-.3-4.265-1.792-4.57-4.477zM49.382 5.682c-.466 1.494-1.482 2.178-3.044 2.051 1.496.466 2.181 1.48 2.054 3.04.467-1.493 1.481-2.178 3.043-2.05-1.496-.467-2.18-1.481-2.053-3.041zM11.395 17.477c-.255 2.08-1.528 3.238-3.82 3.469 2.292.231 3.565 1.388 3.82 3.469.255-2.08 1.528-3.237 3.82-3.47-2.291-.23-3.565-1.388-3.82-3.468zm0 45.792c-.255 2.08-1.528 3.238-3.82 3.469 2.292.231 3.565 1.388 3.82 3.469.255-2.08 1.528-3.237 3.82-3.47-2.291-.23-3.565-1.388-3.82-3.468zm51.39 39.548c-.487 4.37-2.918 6.8-7.293 7.285 4.375.485 6.806 2.916 7.292 7.285.486-4.37 2.917-6.8 7.292-7.285-4.375-.485-6.805-2.915-7.292-7.285zM25.63 127.1c-.416 3.746-2.5 5.83-6.25 6.245 3.75.416 5.834 2.499 6.25 6.244.417-3.745 2.5-5.828 6.25-6.244-3.75-.416-5.832-2.499-6.25-6.245zm38.89 9.02c-.325 2.914-1.945 4.534-4.862 4.857 2.917.324 4.537 1.944 4.861 4.856.324-2.912 1.945-4.532 4.861-4.856-2.916-.323-4.536-1.943-4.86-4.857z" fill="#EFC75E" fill-rule="nonzero" mask="url(#g)"/>
                                </g>
                                <path d="M105.72 34.09v.195h-.193v166.009h-76.17v2.062h76.17v.193h11.937V46.055h70.172l-.332 125.748h7.17v30.554h1.315v.295h86.408v-2.062h-75.784V34.09H105.719zm87.761 40.783h.993V46.055h-.993v28.818zm0 83.42h.993V88.962h-.993v69.333z" fill="#F3A93B"/>
                            </g>
                        </g>
                        <path d="m178.66 30.25v207.39l11.363-19.603v-156.83z" fill="#F68B1F"/>
                        <path d="M253.083 146.169c-.795-7.264-8.204-3.64-8.214-3.635 1.737.2 3.399 1.275 3.752 4.504.795 7.268-10.6 16.958-10.6 16.958s-3.709 5.149-.264 10.903c3.444 5.753.265 12.114.265 12.114l-7.48 8.263 3.993-.351 7.949-8.783s3.18-6.359-.266-12.113c-3.444-5.754.266-10.902.266-10.902s11.394-9.69 10.599-16.958" fill="#005145"/>
                        <path d="M238.625 174.458c-3.453-5.723.265-10.842.265-10.842s11.42-9.637 10.624-16.865c-.354-3.212-2.02-4.28-3.761-4.48v.001c-2.39.903-12.748 14.757-12.748 14.757l-3.473-.455c-.623.818-.999 1.32-.999 1.32l-2.472-.324-1.023 37.706 6.356-.554 7.496-8.218s3.187-6.324-.265-12.046" fill="#006C5C"/>
                        <path d="M204.777 160.987c11.761 16.055 15.322 13.236 15.322 13.236l4.292 21.053 1.635-.064-5.07-24.878s-3.562 2.818-15.323-13.236c0 0-5.071-5.883-9.063 3.064-.621 1.392-.877 2.697-.865 3.91l.008-.021c3.993-8.946 9.064-3.064 9.064-3.064" fill="#005145"/>
                        <path d="M203.607 173.419s3.737 1.823 3.31 7.05c-.427 5.228.107 5.471 1.815 7.295 1.71 1.824 7.689 6.565 7.689 6.565l7.67-.302-4.247-20.883s-3.523 2.796-15.162-13.13c0 0-5.019-5.836-8.97 3.04l-.007.02c.06 6.53 7.902 10.345 7.902 10.345" fill="#006C5C"/>
                        <path d="M231.342 176.584c-2.055.604-1.541-2.112-1.541-2.112l5.138-8.448s2.57-5.13.77-6.639c-1.798-1.509-1.284-.301-4.624 2.112-3.34 2.414-2.311.906-2.311.906 2.568-15.993 3.34-23.838 3.34-23.838s-2.827-10.26-8.993-3.923c-.982 1.01-1.715 2.266-2.256 3.662 6.016-5.88 8.778 4.128 8.778 4.128s-.77 7.846-3.34 23.838c0 0-1.028 1.508 2.313-.905 3.34-2.414 2.825-3.621 4.624-2.112 1.798 1.509-.77 6.638-.77 6.638l-5.14 8.449s-.513 2.715 1.542 2.112c2.056-.604 4.11-3.32 4.11.603 0 2.36-1.95 7.01-3.506 10.343l.582-.028s5.395-10.26 5.395-14.182c0-3.923-2.055-1.207-4.11-.604" fill="#009984"/>
                        <path d="M227.812 177.446l5.18-8.459s2.59-5.136.777-6.646c-1.813-1.511-1.295-.303-4.662 2.114-3.368 2.417-2.331.906-2.331.906 2.59-16.011 3.367-23.867 3.367-23.867s-2.785-10.02-8.85-4.134c-2.876 7.377-.316 18.691-.316 18.691s-.063 1.085-3.188-.427a27.23 27.23 0 01-1.992-1.083c-3.262-1.935-4.227.724-3.896 3.278.135 1.034.48 2.052.974 2.74.115.163.107.398.194.583.785 1.665 5.106 10.95 5.578 14.244.45 3.15.115.829-3.714-.23-.58-.162-1.236-.294-1.985-.373-4.122-.437-3.907 2.286-3.472 3.827.166.59.364 1.006.364 1.006 1.486 5.518 4.136 9.445 7.949 11.782 3.813 2.336 7.931 2.556 12.354.659 1.568-3.337 3.367-9.529 3.367-11.892 0-3.927-2.072-1.208-4.144-.604s-1.554-2.115-1.554-2.115z" fill="#00B29B"/>
                        <path d="M236.02 191.529l-5.792-.066c.178 1.591.136 4.01-.339 7.685-1.158 8.956 0 20.713-6.796 21.314-3.357.295-7.07.37-9.97.37 1.37 2.618 2.869 2.805 2.869 2.805s8.262.31 15.059-.29c6.796-.6 5.637-12.357 6.796-21.313 1.63-12.606-1.826-10.505-1.826-10.505" fill="#A2C9DD"/>
                        <path d="M230.443 191.616l-20.167-.219c-.656-.006-1.142.656-.998 1.357.418 2.045 1.088 6.702 1.27 16.04.118 6.124 1.46 10.001 2.575 12.038 2.99 0 7.509.29 10.968 0 7.004-.591 4.808-12.858 6.002-21.662.49-3.612.532-5.99.35-7.554z" fill="#C3E4F7"/>
                        <path d="m27.764 45.401c-3.489 0-6.317-2.813-6.317-6.284 0-3.47 2.828-6.284 6.317-6.284 3.49 0 6.318 2.813 6.318 6.284 0 3.47-2.829 6.284-6.318 6.284zm0-2.285c2.22 0 4.02-1.79 4.02-3.999 0-2.208-1.8-3.999-4.02-3.999s-4.02 1.79-4.02 4c0 2.208 1.8 3.998 4.02 3.998zm80.792-30.547c-3.49 0-6.318-2.814-6.318-6.285 0-3.47 2.829-6.284 6.318-6.284s6.317 2.814 6.317 6.284c0 3.471-2.828 6.285-6.317 6.285zm0-2.286c2.22 0 4.02-1.79 4.02-3.999 0-2.208-1.8-3.999-4.02-3.999s-4.02 1.79-4.02 4c0 2.208 1.8 3.998 4.02 3.998zm176.23 44.677c-3.49 0-6.318-2.813-6.318-6.283 0-3.471 2.829-6.285 6.318-6.285s6.317 2.814 6.317 6.285c0 3.47-2.828 6.284-6.317 6.284zm0-2.284c2.22 0 4.02-1.79 4.02-4 0-2.208-1.8-3.998-4.02-3.998s-4.02 1.79-4.02 3.999c0 2.208 1.8 3.999 4.02 3.999z" fill="#F3A93C" fill-rule="nonzero"/>
                        <g stroke="#00C59D" stroke-linecap="round" stroke-linejoin="bevel" stroke-width="2">
                            <path d="m16.348 122.06 0.154 5.265m-2.235 2.718-5.477 0.037m7.749 2.955-0.039 5.267m8.718-8.332-5.475 0.037"/>
                        </g>
                        <g stroke="#00C59D" stroke-linecap="round" stroke-linejoin="bevel" stroke-width="2">
                            <path d="m277.56 174.01 0.153 5.266m-2.235 2.717-5.476 0.037m7.749 2.956-0.039 5.267m8.718-8.333-5.475 0.037"/>
                        </g>
                        <g stroke="#00C59D" stroke-linecap="round" stroke-linejoin="bevel" stroke-width="2">
                            <path d="m300.08 96.002 0.154 5.265m-2.235 2.718-5.476 0.036m7.749 2.957-0.04 5.266m8.718-8.333-5.475 0.037"/>
                        </g>
                    </g>
                </svg>

              </div>
              <h1>{{t('Sorry!')}}</h1><br>
              {{t('The event is not available.')}}<br>
              <template  v-if="courseNewManagers.length !== 0">
                {{t('Please contact ')}}
                  <template class="col-sm mb-2" v-for="manager in courseNewManagers">
                      <a class="app-a" v-if="manager.marketplace_contact ==='1'" v-bind:href="'mailto:' + manager.email">{{manager.name}} {{manager.lastname}}</a>,<br/>
                  </template>
                {{t('for more information')}}
              </template>
              <template v-else>
                  <a class="app-a"  href="/marketplace/list">{{t('Go back to the catalogue to find other events')}}</a>
              </template>
            </div>
          </div>
      </template><!-- /SHOW COURSE CONTENT -->
      <template v-else-if="notAvailableForLearner">
        <section class="learner-in-draft">
          <ol class="breadcrumb d-none d-sm-flex">
            <li v-for="item in course.breadcrumb" v-bind:key="item" class="breadcrumb-item">
              <a :href="item.url">
                {{translateHome(item.text)}}
              </a>
            </li>
            <li class="breadcrumb-item active">{{course.name}}</li>
          </ol>

          <DoorPlanetsIcon />

          <h1>{{ t('Sorry !') }}</h1>

          <p>{{ t('The event is not available.') }}</p>
          <p v-if="course.coursemanagers && course.coursemanagers.length > 0">{{ t('Please contact') }} <a :href="`mailto:${course.coursemanagers[0].email}`">{{ [course.coursemanagers[0].name, course.coursemanagers[0].lastname].filter(n=>n).join(' ') }}</a> {{ t('for more information') }}</p>
          <p v-else>{{ t('Please contact your manager for more infomation') }}</p>
          <a href="/marketplace/list" class="btn btn-orange">{{ t('View other events') }}</a>
        </section>
      </template>
      <template v-else><!-- SHOW COURSE ALTERNATIVE CONTENT -->
      <div v-if="course.is_coming_soon && course.coming_soon_date" class="coming-soon-date-time"><strong>{{ t('REGISTRATION OPENS ON:') }}</strong> {{ course.coming_soon_date | formatComingSoonDate }} <span v-if="course.coming_soon_hour">{{ t('at') }} {{ course.coming_soon_hour | formatComingSoonHour }}</span></div>
      <section class="main-section pt-4 pb-0">
        <!-- End Course mobile header -->
        <div v-if="showMobileHeader"
             :style="{borderTopColor: _.get(corporation, 'color_filters', null)}"
             class="header course-mobile fixed-mobile clearfix d-block d-sm-none">
          <nav class="row">
            <div class="col-6">
              <label class="price m-sm-top" style="font-size: 18px;"
                     v-if="course.price == 'Free' && !isEnrollDisabled">{{course.price}}</label>
              <label class="price m-sm-top" style="font-size: 18px;"
                     v-else-if="!isEnrollDisabled">{{course.price}}</label>
            </div>

            <div class="col-6">
              <button v-if="showEnroll"
                      @click="isEnrollDisabled ? null : showEnrollModal()"
                      :style="corporationStyles"
                      v-bind:class="{'disabled': isEnrollDisabled}"
                      type="button" class="btn btn-big enroll-btn m-0-top-bottom m-0-left-right">
                {{t('Enroll')}}


              </button>

              <button v-else-if="showWaitList"
                      @click="addToWaitListOpen(course)"
                      type="button" class="btn btn-big waitlist small m-0-top-bottom m-0-left-right">
                {{custom_waitlist_count && firstBttn ? firstBttn : t('Waitlist')}}
              </button>

              <button v-else-if="showWaitListFull"
              		  @click=""
                      type="button"
                      class="btn btn-big full small m-0-top-bottom m-0-left-right" >
                {{t('Full')}}
              </button>
              
              <button v-else-if="showWaitingWaitList"
              		  @click="removeFromWaitList(course.id)"
                      type="button"
                      class="btn btn-big waiting small m-0-top-bottom m-0-left-right" >
                {{custom_waitlist_count && secondBttn ? secondBttn : t('Waiting')}}
              </button>

              <button v-else-if="showSoldOut"
                      @click=""
                      :class="{'disabled': true}"
                      style="cursor: initial;"
                      type="button" class="btn btn-big soldout m-0-top-bottom m-0-left-right">
                {{t('Soldout')}}
              </button>
            </div>
          </nav>

          <div class="row">
            <div class="col-12 text-center">
              <button @click="toggleGoToSection()"
                      :style="{color: _.get(corporation, 'color_filters', null)}"
                      class="btn btn-link app-a p-0-top-bottom">
                {{t('Go to section')}}
                <i v-if="!expandGoToSection" style="vertical-align: initial;"
                   class="fa fa-chevron-down m-xs-left"></i>
                <i v-if="expandGoToSection" style="vertical-align: initial;"
                   class="fa fa-chevron-up m-xs-left"></i>
              </button>
            </div>
          </div>

          <div v-if="expandGoToSection"
               :style="{borderColor: _.get(corporation, 'color_filters', null)}"
               class="clearfix row sections-menu">
            <div class="col-md-12 col-12 text-left">
              <ul class="list-group m-0-bottom">
                <li @click="goToSection('section_top')"
                    :style="{color: _.get(corporation, 'color_filters', null)}"
                    class="list-group-item">
                 {{t('Top')}}
                </li>
                <li v-for="tabItem in _.get(course,'tabs', [])"
                    :style="{color: _.get(corporation, 'color_filters', null)}"
                    @click="goToSection('section_'+tabItem.title)"
                    class="list-group-item">
                  {{tabItem.title}}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- End mobile search -->
        <div class="course-breadcrumb mt-2 mb-5" :class="{ 'has-manage-btn': hasManageBtn }">
          <ol class="breadcrumb d-none d-sm-flex my-0">
            <li v-for="item in course.breadcrumb" v-bind:key="item" class="breadcrumb-item">
              <a :href="item.url"
                :style="{color: _.get(corporation, 'color_filters', null) }">
                {{translateHome(item.text)}}
              </a>
            </li>
            <li v-for="(item, index) in categoriesValues" :key="item" class="breadcrumb-item">
                <a :href="getPath(index)"
                  :style="{color: _.get(corporation, 'color_filters', null) }">
                  {{ item | toStartCase }}
                </a>
            </li>
            <li class="breadcrumb-item active">{{ course.name }}</li>
            <li v-if="!course.id" class="breadcrumb-item active" aria-current="page">&nbsp;</li>
          </ol>
          <a v-if="hasManageBtn && isPath" class="btn-manage-event btn-path btn-outline-primary waves-effect waves-themed" :href="`/apprendo/dashboard#/course/${course.id_course}/manage`">{{ t('Manage Path') }}</a>
          <a v-else-if="hasManageBtn" class="btn-manage-event btn-app btn-primary no-box waves-effect waves-themed" :href="`/apprendo/dashboard#/course/${course.id_course}/manage`">{{ t('Manage Event') }}</a>
        </div>
        <div v-if="course.id" class="row" ref="section_top">
          <div class="col-12">
            <div class="row">
              <div class="col-md-9 col-12">
                <div class="course-header" :class="{ 'is-path': isPath, }">
                  <HeartReactionIcon v-if="!isPath" :course="course" />
                  <span class="title-description">{{course.name}}</span>
                </div>
                <div class="name-rating d-none">
                  <div class="starts-rating">
                    <i class="bg-rating"></i>
                    <i class="bg-rating"></i>
                    <i class="bg-rating"></i>
                    <i class="bg-rating-mid"></i>
                    <i class="bg-rating-null"></i>
                  </div>
                </div>
              <div class="row d-sm-block mt-2" :class="{ 'd-none': !isPath }">
	              <div v-if="isPath" class="col-md-9 col-12 div-is-path">
                  <BlendedIcon width="24" height="24" :color="'#78909c'" /> {{ t('PATH') }}
                </div>
	              <div v-else class="col-md-9 col-12">
		              <span class="float-left mr-5">
		                <course-type-icon :type="course.course_type" :color="_.get(corporation, 'color_filters', null)"></course-type-icon>
		                <label :style="{color: _.get(corporation, 'color_filters', null) }"
		                       style="margin-bottom: 0;font-weight: normal;text-transform: uppercase;">
                      <template v-if="course.course_type === 'online'">{{ t('ONLINE EVENT') }}</template>
                      <template v-if="course.course_type === 'onsite'">{{ t('ONSITE EVENT') }}</template>
                      <template v-if="course.course_type === 'blended'">{{ t('BLENDED EVENT') }}</template>
		                </label>
		              </span>

		              <span v-if="course.time_option === 2 && _.get(course, 'locations', []).length"
		                   @click="goToSection('section_location')"
		                   class="link-event text-left mr-5">
		                	<location-icon :color="_.get(corporation, 'color_filters', null)"></location-icon>

		                <a :style="{color: _.get(corporation, 'color_filters', null) }"
		                       style="margin-bottom: 0;font-weight: normal;" class="app-a">{{t('VIEW LOCATION')}}</a>
		              </span>

		              <span class="link-event" v-if="hasTabs && course.coursemanagers && course.coursemanagers.length>0" @click="goToSection('section_tabs')">
		                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" class="mr-1">
		                		<g id="Course-Templates" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Template-1-/-Course-Info" transform="translate(-403 -263)" fill="#256AB3"><g id="TOP-INFO" transform="translate(48 203)"><g id="sub-info" transform="translate(0 58)"><g id="questions" transform="translate(353)"><g id="icon/misc/question"><path d="M9.655 19H3.5A1.5 1.5 0 012 17.5v-14A1.5 1.5 0 013.5 2h17A1.5 1.5 0 0122 3.5v14a1.5 1.5 0 01-1.5 1.5h-6.204l-1.88 2.78a.5.5 0 01-.825.005L9.655 19zm3.961-.78a.5.5 0 01.414-.22h6.47a.5.5 0 00.5-.5v-14a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v14a.5.5 0 00.5.5h6.416a.5.5 0 01.41.215l1.67 2.4 1.62-2.395zm-2.286-5.96a2.55 2.55 0 01.037-1.057 3.73 3.73 0 01.353-.87c.15-.266.322-.513.518-.743.195-.23.377-.457.547-.682.17-.226.312-.453.428-.683.115-.23.172-.48.172-.75 0-.4-.122-.742-.367-1.027-.246-.286-.608-.428-1.088-.428-.33 0-.642.077-.938.233a2.65 2.65 0 00-.787.637L9.5 6.245c.32-.36.692-.657 1.117-.893.426-.235.913-.352 1.463-.352.76 0 1.367.212 1.822.638.456.425.683 1.012.683 1.762 0 .33-.06.63-.18.9s-.267.525-.442.765c-.176.24-.36.477-.555.713a8.29 8.29 0 00-.54.727c-.166.25-.293.517-.383.802a2.28 2.28 0 00-.075.953h-1.08zm.57 3.15a.843.843 0 01-.63-.262.919.919 0 01-.255-.668c0-.29.085-.522.255-.697a.843.843 0 01.63-.263c.25 0 .462.087.637.263.176.175.263.407.263.697 0 .27-.087.492-.263.668a.868.868 0 01-.637.262z" id="Combined-Shape"/>
		                		</g></g></g></g></g></g>
		                	</svg>

		                <a v-if="hasTabs" :style="{color: _.get(corporation, 'color_filters', null) }"
		                       style="margin-bottom: 0;font-weight: normal;" class="app-a">{{t('QUESTIONS?')}}</a>
		              </span>


           		 </div>
           		</div>
                <div class="name-description d-none d-sm-block mb-4">
                  <p class="m-0-bottom fr-view text-to-increase" v-html="$sanitize(course.description)"></p>
                </div>
              </div>

              <div class="col-md-3 col-12 d-sm-block" data-agastya-ignore :class="{ 'd-none': !isPath }">
                <div v-if="!isPath" class="text-right">
                  <div class="price-wrap">
                    <i v-if="false" class="new-bg-ok-green">
                      <span>{{course.wishlist.available}}/{{course.wishlist.space}}</span>
                    </i>
                    <!-- AQUI VA EL PRICE -->

                      <h4 v-if="freeSeats(course.price, course.highest_price)">{{t('FREE')}}</h4>
                      <h4 v-else>{{getRangeOfPrices(course.price, course.highest_price)}}</h4>

                    <!-- <h4 v-if="course.price != 'Free' && !isEnrollDisabled">{{course.price}}</h4> -->
                  <!-- <h4  v-else-if="!isEnrollDisabled">{{course.price}}</h4> -->
                </div>
                <br>
                  <button v-if="showComingSoon" type="button" style="cursor: initial;" class="btn coming-soon-btn small m-xs-left">{{ t('Coming Soon') }}</button>
                  
                  <button v-else-if="showEnroll && canEnrollByAllowedDomains"
                          @click="trackEnrollClick"
                          :style="corporationStyles"
                          v-bind:class="{'disabled': isEnrollDisabled}"
                          name="testing_anchor_enroll-button"
                          type="button" class="btn btn-big enroll-btn m-xs-left">
                    {{t('Enroll')}}
                  </button>

                  <button v-else-if="!canEnrollByAllowedDomains"
                          type="button" class="btn btn-big soldout m-xs-left disabled">
                    {{t('Not allowed')}}
                  </button>

                  <button v-else-if="showWaitList"
                          @click="addToWaitListOpen(course)"
                          type="button" class="btn btn-big waitlist m-xs-left">
                    {{custom_waitlist_count && firstBttn ? firstBttn : t('Waitlist')}}
                  </button>

                  <button v-else-if="showWaitListFull"
              		  @click=""
                          type="button" class="btn btn-big full small m-xs-left" >
                    {{t('Full')}}
                  </button>
                  
                  <button v-else-if="showWaitingWaitList"
              		  @click="removeFromWaitList(course.id)"
                          type="button" class="btn btn-big waiting small m-xs-left" >
                    {{custom_waitlist_count && secondBttn ? secondBttn : t('Waiting')}}
                  </button>

                  <button v-else-if="showSoldOut"
                          @click=""
                          :class="{'disabled': true}"
                          style="cursor: initial;"
                          type="button" class="btn btn-big soldout m-xs-left">
                    {{t('Soldout')}}
                  </button>

                  <button v-else-if="showViewCourse && showRecertification"
                          @click="reCertification()"
                          :style="corporationStyles"
                          type="button" class="btn btn-big enroll-btn m-0-top-bottom m-0-left-right">
                    {{t('Re-Certification')}}
                  </button>


                  <button v-else-if="showViewCourse"
                          type="button" class="btn btn-light full-btn app-outline big mt-2 mb-3">

              <label v-if="course.course_type=='onsite'" class="no-btn mb-0" style="cursor: initial;">
              	{{t('You are already')}}<br/>
              	{{t('enrolled in this event')}}</label>

              <label v-if="course.course_type!='onsite'" class="mb-0"><a :href="'index.php?r=courseModule&idCourse='+course.id">{{t('View Content')}}</a></label>

            </button>
            <div v-if="showViewCourse && isEnrollMultiple()">
                <span class="text-right ml-2"><a class="link-app" href="#" @click="isEnrollDisabled ? null : showEnrollModal()" >{{t('Enroll Others')}}</a></span>
             </div>
                </div>
                <div v-else>
                  <div class="row is-path mb-4">
                    <div class="col">
                      <div><CourseIcon height="24" width="24" :color="'#00aeef'" /><span>{{ _.get(course, 'pathways').length  }}</span></div>
                      <div>{{ t('EVENTS') }}</div>
                    </div>
                    <!-- REWARDS -->
                    <div v-if="!isPath" class="col">
                      <div><RewardIcon /><span>0</span></div>
                      <div>{{ t('REWARD') }}</div>
                    </div>
                    <!-- /REWARDS -->
                  </div>

                  <button type="button" class="btn btn-manage-event btn-path btn-outline-primary btn-block" @click="unfollowPath" v-if="course.course_people_data && !!course.course_people_data.pathway_enroll_type">{{ t('Unfollow') }}</button>
                  <button type="button" class="btn btn-highlight btn-block" @click="!!course.courseEntityStructure ? showEnrollModal() : openFollowPath()" v-else >{{ t('Follow the Path') }}</button>

                  <div class="row pt-5" v-if="course.coursemanagers.length > 0 && !isPath">
                    <p class="font-weight-bold col-12">{{ t('Questions?') }}</p>
                    <div class="col-12 table-responsive">
                      <div class="coursemanagers-info">
                        <span><p>{{ course.coursemanagers[0].name }} {{ course.coursemanagers[0].lastname }}</p><p><a class="app-a" v-bind:href="'mailto:' + course.coursemanagers[0].email">{{course.coursemanagers[0].email}}</a></p></span>
                        <img :src="course.coursemanagers[0].profile_picture ? '/files/profile/'+course.coursemanagers[0].profile_picture : '/webroot/images/user_placeholder.jpg'"
                                  width="48" height="48"
                                  alt="cmpic" class="cmquestion">
                      </div><!-- .coursemanagers-info -->
                    </div><!-- .col-12 -->
                  </div>
                  
                </div>


              </div>
            </div>

            <div class="row d-flex d-sm-none m-sm-top" v-if="!isPath">
              <div class="col-5">
                <course-type-icon :type="course.course_type" :color="_.get(corporation, 'color_filters', null)"></course-type-icon>
                <label :style="{color: _.get(corporation, 'color_filters', null) }"
                       style="margin-bottom: 0;font-weight: normal;text-transform: uppercase;">
                  {{course.course_type}}
                </label>
              </div>

              <span v-if="hasTabs && course.coursemanagers && course.coursemanagers.length>0" @click="goToSection('section_tabs_mobile')" class="link-event">
		                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" class="mr-1">
		                		<g id="Course-Templates" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Template-1-/-Course-Info" transform="translate(-403 -263)" fill="#383838"><g id="TOP-INFO" transform="translate(48 203)"><g id="sub-info" transform="translate(0 58)"><g id="questions" transform="translate(353)"><g id="icon/misc/question"><path d="M9.655 19H3.5A1.5 1.5 0 012 17.5v-14A1.5 1.5 0 013.5 2h17A1.5 1.5 0 0122 3.5v14a1.5 1.5 0 01-1.5 1.5h-6.204l-1.88 2.78a.5.5 0 01-.825.005L9.655 19zm3.961-.78a.5.5 0 01.414-.22h6.47a.5.5 0 00.5-.5v-14a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v14a.5.5 0 00.5.5h6.416a.5.5 0 01.41.215l1.67 2.4 1.62-2.395zm-2.286-5.96a2.55 2.55 0 01.037-1.057 3.73 3.73 0 01.353-.87c.15-.266.322-.513.518-.743.195-.23.377-.457.547-.682.17-.226.312-.453.428-.683.115-.23.172-.48.172-.75 0-.4-.122-.742-.367-1.027-.246-.286-.608-.428-1.088-.428-.33 0-.642.077-.938.233a2.65 2.65 0 00-.787.637L9.5 6.245c.32-.36.692-.657 1.117-.893.426-.235.913-.352 1.463-.352.76 0 1.367.212 1.822.638.456.425.683 1.012.683 1.762 0 .33-.06.63-.18.9s-.267.525-.442.765c-.176.24-.36.477-.555.713a8.29 8.29 0 00-.54.727c-.166.25-.293.517-.383.802a2.28 2.28 0 00-.075.953h-1.08zm.57 3.15a.843.843 0 01-.63-.262.919.919 0 01-.255-.668c0-.29.085-.522.255-.697a.843.843 0 01.63-.263c.25 0 .462.087.637.263.176.175.263.407.263.697 0 .27-.087.492-.263.668a.868.868 0 01-.637.262z" id="Combined-Shape"/>
		                		</g></g></g></g></g></g>
		                	</svg>

		                <a v-if="hasTabs" :style="{color: _.get(corporation, 'color_filters', null) }"
		                       style="margin-bottom: 0;color: #337ab7;font-weight: normal;" class="app-a">{{t('QUESTIONS?')}}</a>
		              </span>

              <div v-if="course.time_option === 2 && _.get(course, 'locations', []).length"
                   @click="goToSection('section_location')"
                   class="link-event col-sm">
                <location-icon :color="_.get(corporation, 'color_filters', null)"></location-icon>

                <label :style="{color: _.get(corporation, 'color_filters', null) }"
                       style="margin-bottom: 0;color: #337ab7;font-weight: normal;" class="app-a">{{t('VIEW LOCATION')}}</label>
              </div>
            </div>

            <div v-if="hasImages" class="row d-flex d-sm-none">
              <div class="col-12 m-md-bottom m-sm-bottom">
                <course-images-carousel :comments="course.carousel.length > 0 ? course.carousel : course.pathways && course.pathways.find(p=>p.category.image) ? [{ 'url_body': course.pathways.find(p=>p.category.image).category.image }] : [{ 'url_body': `/index.php?r=course/getFile&courseid=${course.pathways.find(p=>p.category && p.category.asMainCourse.find(c=>c.course.course_image)).category.asMainCourse.find(c=>c.course.course_image).course.id_course}&file=${course.pathways.find(p=>p.category && p.category.asMainCourse.find(c=>c.course.course_image)).category.asMainCourse.find(c=>c.course.course_image).course.course_image}` }]"
                                        :show-review="true"></course-images-carousel>
              </div>
            </div>

            <div class="row d-flex d-sm-none" v-if="!isPath">
              <div class="col-12">
                <div ref="section_basic">
                  <p class="m-0-bottom fr-view pt-3" v-html="$sanitize(course.description)"></p>
                </div>

                <div class="text-left p-sm-top" ref="mobileEnrollBtn">
                  <h4 v-if="freeSeats(course.price, course.highest_price)">{{t('FREE')}}</h4>
                      <h4 v-else>{{getRangeOfPrices(course.price, course.highest_price)}}</h4>
                </div>

                <button v-if="showEnroll"
                        @click="trackEnrollClick"
                        :style="corporationStyles"
                        v-bind:class="{'disabled': isEnrollDisabled}"
                        type="button" class="btn btn-big enroll-btn ">
                  {{t('Enroll')}}
                </button>

                <button v-else-if="showWaitList"
                        @click="addToWaitListOpen(course)"
                        type="button" class="btn btn-big waitlist small m-xs-left">
                  {{custom_waitlist_count && firstBttn ? firstBttn : t('Waitlist')}}
                </button>

                <button v-else-if="showWaitListFull"
                        @click=""
                        type="button" class="btn btn-big full small m-xs-left" >
                  {{t('Full')}}
                </button>
                
                <button v-else-if="showWaitingWaitList"
                        @click="removeFromWaitList(course.id)"
                        type="button" class="btn btn-big waiting small m-xs-left" >
                  {{custom_waitlist_count && secondBttn ? secondBttn : t('Waiting')}}
                </button>

                <button v-else-if="showSoldOut"
                        @click=""
                        :class="{'disabled': true}"
                        style="cursor: initial;"
                        type="button" class="btn btn-big soldout m-xs-left">
                  {{t('Soldout')}}
                </button>



              </div>
            </div>

            <div v-if="false" class="col-12 d-block d-sm-none p-md-left-right m-md-bottom">
              <div class="price-wrap pull-right mb-3">
                <i class="new-bg-ok-green">
                  <span> {{course.wishlist.available}} / {{course.wishlist.space}}</span>
                </i>
              </div>
            </div>
          </div>
        </div>

        <div v-if="course.wishlist" class="row m-sm-top course-info d-none d-sm-block">
          <div class="col-12">
            <ul class="list-inline course-options text-center big-block">
              <li class="text-center list-inline-item">
                <div class="border-right">
                  <i class="bg-location"></i>
                  <label>{{t('Mode')}}</label>
                  <p>{{course.mode}}</p>
                </div>
              </li>
              <li class="text-center list-inline-item">
                <div class="border-right">
                  <i class="bg-webinar"></i>
                  <label>{{t('Type')}}</label>
                  <p>{{course.type}}</p>
                </div>
              </li>
              <li class="text-center list-inline-item">
                <div class="border-right">
                  <i class="bg-age"></i>
                  <label>{{t('Age')}}</label>
                  <p>{{course.age}}</p>
                </div>
              </li>
              <li class="text-center list-inline-item">
                <div class="border-right">
                  <i class="bg-level"></i>
                  <label>{{t('Level')}}</label>
                  <p>{{course.level}}</p>
                </div>
              </li>
              <li class="text-center list-inline-item">
                <div class="border-right">
                  <i class="bg-language"></i>
                  <label>{{t('Language')}}</label>
                  <p>{{course.language}}</p>
                </div>
              </li>
              <li class="text-center list-inline-item">
                <div class="border-right">
                  <i class="bg-start"></i>
                  <label>{{t('Starts')}}</label>
                  <p>{{course.starts}}</p>
                </div>
              </li>
              <li class="text-center list-inline-item">
                <div class="border-right">
                  <i class="bg-finish"></i>
                  <label>{{t('Duration')}}</label>
                  <p>{{course.days}}</p>
                </div>
              </li>
              <li class="text-center list-inline-item">
                <div class="border-right">
                  <i class="bg-weekly"></i>
                  <label>{{t('Created')}}</label>
                  <p>{{course.created_date}}</p>
                </div>
              </li>
              <li class="text-center list-inline-item">
                <div class="border-right">
                  <i class="bg-hours"></i>
                  <label>{{t('Last Update')}}</label>
                  <p>{{course.last_update_date}}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div v-if="schedule.length || (course.course_start_date && course.course_end_date)" class="col-12" data-agastya-ignore>
          <div  class="row schedule-table">
            <div class="col-12 pb-3 pt-4 d-none d-sm-block">
              <div class="row">
                <div class="col-auto"><DateIcon /></div>
                <div class="col">
                  <h5 v-if="course.course_start_date && course.course_end_date">
                    <b>{{t('From:')}}</b>&nbsp;{{ course.course_start_hour ? mergeDateTime(course.course_start_date, course.course_start_hour) : course.course_start_date | formatDateApp(timezoneHelper(course)) }}
                    <b>{{t('Until:')}}</b>&nbsp;{{ course.course_end_hour ? mergeDateTime(course.course_end_date, course.course_end_hour) : course.course_end_date | formatDateApp(timezoneHelper(course)) }}
                  </h5>
                </div>
              </div>
              <div v-if="course.time_option === 2 && getLocationDesc(course.location) && course.location_option === 1" class="row mt-3">
                <div class="col-auto"><LocationBIcon height="24" width="24" :color="'#263238'" /></div>
                <div class="col" v-html="$sanitize(getLocationDesc(course.location))" style="white-space: pre-wrap;"></div>
              </div>
            </div>
            <div class="col-12 py-3 d-block d-sm-none">
              <div class="row" v-if="course.course_start_date && course.course_end_date">
                <div class="col-12">
                  
                </div>
                <div class="row">
                  <div class="col-auto"><DateIcon /></div>
                  <div class="col">
                    <div>
                      <b>{{t('From:')}}</b>&nbsp;{{ course.course_start_hour ? mergeDateTime(course.course_start_date, course.course_start_hour) : course.course_start_date | formatDateApp(timezoneHelper(course)) }}
                    </div>
                    <div>
                      <b>{{t('Until:')}}</b>&nbsp;{{ course.course_end_hour ? mergeDateTime(course.course_end_date, course.course_end_hour) : course.course_end_date | formatDateApp(timezoneHelper(course)) }}
                    </div>
                  </div>
                </div>
                <div v-if="course.time_option === 2 && getLocationDesc(course.location) && course.location_option === 1" class="row mt-3">
                  <div class="col-auto"><LocationBIcon height="24" width="24" :color="'#263238'" /></div>
                  <div class="col" v-html="$sanitize(getLocationDesc(course.location))" style="white-space: pre-wrap;"></div>
                </div>
              </div>
            </div>
            <template v-if="course.time_option === 3">
              <div v-for="scheduleDay in schedule" :key="scheduleDay"
                 class="col-lg-4 col-md-4 col-12 pb-3 col-md-6 p-0-right">
              <div class="date-area display-inline-block">
                <div class="month">
                  <span>{{ scheduleDay.date | formatShortMonth(timezoneHelper(course)) }}</span>
                </div>
                <div class="day">
                  <span>{{ scheduleDay.date | formatDay(timezoneHelper(course)) }}</span>
                </div>
              </div>

              <label class="time" v-if="scheduleDay.start_hour && scheduleDay.end_hour">
                {{ mergeDateTime(scheduleDay.date, scheduleDay.start_hour) | formatTime(timezoneHelper(course)) }} {{t('to')}} {{ mergeDateTime(scheduleDay.date, scheduleDay.end_hour) | formatTime(timezoneHelper(course)) }}
              </label>
              <div v-if="getLocationDesc(scheduleDay.location) && scheduleDay.location_option" class="row no-gutters mt-3">
                <div class="col-auto pr-2"><LocationBIcon height="24" width="24" :color="'#263238'" /></div>
                <div class="col" v-html="$sanitize(getLocationDesc(scheduleDay.location))" style="white-space: pre-wrap;"></div>
              </div>
            </div>
            <div class="col-12 mb-4 clearfix"></div>
            </template>
            <div class="col-12"><p class="mb-0 p-timezone">*{{ t('All the displayed times are in the') }}&nbsp;{{ course.course_start_hour ? mergeDateTime(course.course_start_date, course.course_start_hour) : course.course_start_date | formatTimezone(timezoneHelper(course)) }}&nbsp;{{ t('timezone') }}</p></div>
          </div>
        </div>

        <div class="row m-md-top course-info d-block" :class="{ 'd-sm-none': !isPath }">
          <div class="col-12">
            <ul class="list-inline course-options m-0-bottom text-center big-block">
              <li class="text-center list-inline-item">
                <div class="border-right">
                  <i class="bg-location left-align"></i>
                  <label>{{t('Mode')}}</label>
                  <p>{{course.mode}}</p>
                </div>
              </li>
              <li class="text-center list-inline-item">
                <div class="border-right move-right">
                  <i class="bg-webinar"></i>
                  <label>{{t('Type')}}</label>
                  <p>{{course.type}}</p>
                </div>
              </li>
            </ul>
          </div>
          <div class="col-12">
            <ul class="list-inline course-options m-0-bottom middle-block text-center big-block">
              <li class="text-center list-inline-item">
                <div class="border-right">
                  <i class="bg-age"></i>
                  <label>{{t('Age')}}</label>
                  <p>{{course.age}}</p>
                </div>
              </li>
              <li class="text-center list-inline-item">
                <div class="border-right move-right">
                  <i class="bg-level"></i>
                  <label>{{t('Level')}}</label>
                  <p>{{course.level}}</p>
                </div>
              </li>
            </ul>
          </div>
          <div class="col-12">
            <ul class="list-inline course-options m-0-bottom middle-block text-center big-block">
              <li class="text-center list-inline-item">
                <div class="border-right">
                  <i class="bg-language"></i>
                  <label>{{t('Language')}}</label>
                  <p>{{course.language}}</p>
                </div>
              </li>
              <li class="text-center list-inline-item">
                <div class="border-right move-right">
                  <i class="bg-start"></i>
                  <label>{{t('Starts')}}</label>
                  <p>{{course.starts}}</p>
                </div>
              </li>
            </ul>
          </div>
          <div class="col-12">
            <ul class="list-inline course-options m-0-bottom middle-block text-center big-block">
              <li class="text-center list-inline-item">
                <div class="border-right">
                  <i class="bg-finish"></i>
                  <label>{{t('Duration')}}</label>
                  <p>{{course.days}}</p>
                </div>
              </li>
              <li class="text-center list-inline-item">
                <div class="border-right move-right">
                  <i class="bg-weekly"></i>
                  <label>{{t('Created')}}</label>
                  <p>{{course.created_date}}</p>
                </div>
              </li>
            </ul>
          </div>

          <div class="col-12">
            <ul class="list-inline course-options middle-block  text-center big-block">
              <li class="text-center list-inline-item">
                <div class="border-right">
                  <i class="bg-hours"></i>
                  <label>{{t('Last Update')}}</label>
                  <p>{{course.last_update_date}}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div v-if="hasImages" class="row d-none d-sm-block">
          <div class="col-md-12 col-sm-12 col-12 m-sm-bottom">
            <course-images-carousel :comments="course.carousel.length > 0 ? course.carousel : course.pathways && course.pathways.find(p=>p.category.image) ? [{ 'url_body': course.pathways.find(p=>p.category.image).category.image }] : [{ 'url_body': `/index.php?r=course/getFile&courseid=${course.pathways.find(p=>p.category && p.category.asMainCourse.find(c=>c.course.course_image)).category.asMainCourse.find(c=>c.course.course_image).course.id_course}&file=${course.pathways.find(p=>p.category && p.category.asMainCourse.find(c=>c.course.course_image)).category.asMainCourse.find(c=>c.course.course_image).course.course_image}` }]"
                                    :show-review="true">
            </course-images-carousel>
          </div>
        </div>

        <div class="row info-bar">
          <div class="col-md-6 col-sm-6 col-12 p-md-top">
            <label>{{t('Categories')}}</label>
            <div>
              <span class="blue m-sm-right categories-course"
                    v-for="topic in course.topics" :key="topic">
                &nbsp;&nbsp;&nbsp;{{topic.name}}&nbsp;
              </span>
            </div>
          </div>

          <div class="col-md-6 col-sm-6 col-12 p-md-top">
            <label>{{t('Sub-Categories')}}</label>
            <div>
                <span class="blue m-sm-right categories-course"
                      v-for="subtopic in course.subtopics">
                        &nbsp;&nbsp;&nbsp;{{subtopic.name}}&nbsp;
                </span>
            </div>
          </div>
        </div>

        <div v-if="_.get(course, 'tabs', []).length && !isPath" class="row d-block d-sm-none">
          <div v-for="tabItem in course.tabs" :key="tabItem" class="col-md-12 col-sm-12 col-12">
            <div :ref="'section_' + tabItem.title" class="course-section-title">
              <h4>{{titleTab(tabItem.title)}}</h4>
              <hr :style="{borderTopColor: _.get(corporation, 'color_filters', null) }">
            </div>


            <!-- Esto para mobile al parecer -->
            <div v-if="tabItem.title=='About'" class="mb-3" ref="section_tabs_mobile">
            	<svg v-if="course.coursemanagers && course.coursemanagers.length>0" width="28" height="28" xmlns="http://www.w3.org/2000/svg" class="mr-2">
            		<g id="Course-Templates" stroke="none" stroke-width="1" fill="#383838"><g id="Template-1-/-Course-Info" transform="translate(-83 -1118)" >
                <g id="TABS-INFO" transform="translate(-87 1038)"><g id="About-Info" transform="translate(0 78)"><g id="icon/misc/question" transform="translate(168.077)"><path fill="#383838" d="M12.873 25.333H4.667a2 2 0 01-2-2V4.667a2 2 0 012-2h22.666a2 2 0 012 2v18.666a2 2 0 01-2 2h-8.272l-2.506 3.707a.667.667 0 01-1.1.007l-2.582-3.714zm5.282-1.04a.667.667 0 01.552-.293h8.626a.667.667 0 00.667-.667V4.667A.667.667 0 0027.333 4H4.667A.667.667 0 004 4.667v18.666c0 .369.298.667.667.667h8.554c.219 0 .423.107.548.286l2.226 3.202 2.16-3.195zm-3.048-7.946c-.08-.52-.064-.99.05-1.41.113-.42.27-.807.47-1.16.2-.354.43-.684.69-.99.26-.307.503-.61.73-.91.226-.3.416-.604.57-.91.153-.307.23-.64.23-1 0-.534-.164-.99-.49-1.37-.327-.38-.81-.57-1.45-.57-.44 0-.857.103-1.25.31-.394.206-.744.49-1.05.85l-.94-.86c.426-.48.923-.877 1.49-1.19.566-.314 1.216-.47 1.95-.47 1.013 0 1.823.283 2.43.85.606.566.91 1.35.91 2.35 0 .44-.08.84-.24 1.2-.16.36-.357.7-.59 1.02-.234.32-.48.636-.74.95-.26.313-.5.636-.72.97-.22.333-.39.69-.51 1.07a3.04 3.04 0 00-.1 1.27h-1.44zm.76 4.2c-.334 0-.614-.117-.84-.35-.227-.234-.34-.53-.34-.89 0-.387.113-.697.34-.93.226-.234.506-.35.84-.35.333 0 .616.116.85.35.233.233.35.543.35.93 0 .36-.117.656-.35.89-.234.233-.517.35-.85.35z" id="Combined-Shape"/>
            		</g></g></g></g></g>
            	</svg>
            	<b v-if="course.coursemanagers && course.coursemanagers.length>0">{{t('Do you have questions about this event? Contact us:')}}</b>

            	<div v-if="course.coursemanagers && course.coursemanagers.length>0" class="mt-3 mb-4">
            		<div class="row">
            			<div class="col-sm mb-2" v-for="manager in course.coursemanagers">
		            		<div class="cmquestion mr-2">
		            			<img :src="manager.profile_picture ? '/files/profile/'+manager.profile_picture : '/webroot/images/user_placeholder.jpg'"
                                 width="48" height="48"
                                 alt="cmpic" class="img-circle mr-3">

		            		</div>
		            		<div>
			            		<p class="mb-0">{{manager.name}} {{manager.lastname}}</p>
			            		<span class="small"><a class="app-a" v-bind:href="'mailto:' + manager.email">{{manager.email}}</a></span><br/>
			            		<span class="small">{{manager.people_work_phone}}</span>
			            	</div>
			            </div>
			       	  </div>
            	</div>

            	<div v-if="course.hosts.length>0" class="mb-4">
            		<b>{{t('This event features:')}}</b>
            		<span v-for="(host , index) in course.hosts">{{host.category_name}}<template v-if="index+1 < course.hosts.length">, </template></span>
            	</div>
            </div>

            <p class="courseInfop fr-view" v-html="$sanitize(tabItem.body)" v-if="tabItem.body && tabItem.type === 'html'"></p>
            <ul class="list-unstyled" v-if="tabItem.body && tabItem.type === 'list'">
              <li v-for="(listItem, index) in tabItem.body"
                  :key="'tabItem_'+index">
                {{listItem.text}}
              </li>
            </ul>
            <div v-if="tabItem.body && tabItem.type === 'json'">{{tabItem.body.people_about}}</div>
          </div>
        </div>

        <div v-if="_.get(course, 'courseinstructors', []).length">
          <span class="title-description">{{ t('Instructors') }}</span>
          <div class="row cards-container mt-2" style="gap: 1.5rem;">
            <div v-for="instructor in course.courseinstructors" :key="instructor.email" class="col-auto p-0" style="width: 14.875rem">
                <span @click="openInstructor(instructor)" class="card h-100 instructor-link">
                  <img class="card-img-top" :src="instructor.profile_picture ? `/files/profile/${instructor.profile_picture}` : '/webroot/images/user_placeholder.jpg'" :alt="instructor.email" />
                  <div class="card-body">
                    <span class="instructor-name">{{ instructor.name }} {{ instructor.lastname }}</span>
                    <div class="mb-2">
                      <a v-if="!!instructor.site" :href="instructor.site" target="_blank" class="mr-1"><WorldIcon height="24" width="24" /></a>
                      <a v-if="!!instructor.facebook" :href="instructor.facebook" target="_blank" class="mr-1"><facebookIcon height="24" width="24" /></a>
                      <a v-if="!!instructor.linkedin" :href="instructor.linkedin" target="_blank" class="mr-1"><linkedinIcon height="24" width="24" /></a>
                      <a v-if="!!instructor.youtube" :href="instructor.youtube" target="_blank" class="mr-1"><youtubeIcon height="24" width="24" /></a>
                      <a v-if="!!instructor.instagram" :href="instructor.instagram" target="_blank" class="mr-1"><instagramIcon height="24" width="24" /></a>
                      <a v-if="!!instructor.twitter" :href="instructor.twitter" target="_blank" class="mr-1"><twitterXIcon height="24" width="24" /></a>
                      <a v-if="!!instructor.pinterest" :href="instructor.pinterest" target="_blank" class="mr-1"><pinterestIcon height="24" width="24" /></a>
                    </div>
                    <p class="card-text" v-html="$sanitize(instructor.summary)" ></p>
                  </div>
                </span>
            </div><!-- .card -->
          </div>
        </div>

        <div v-if="hasTabs && !isPath" class="row d-none d-sm-block" ref="section_tabs">
          <div class="col-md-12 col-sm-12 col-12">
            <tabs-panel :tabIndex="tabIndex" :tabs="course.tabs" :course="course"></tabs-panel>
          </div>
        </div>

        <div v-if="false && _.get(course, 'locations', []).length" ref="section_location" class="row">
          <location-map :locations="course.locations"></location-map>
        </div>

		<div class="row" v-if="!isPath">
			<div v-if="_.get(course, 'categories', []).length" class="col-sm mb-3">
				<p class="font-weight-bold">{{t('Categories assigned to this event:')}}</p>
				<span v-for="category in course.categories" class="badge-cat">{{category.category_name}}</span>
			</div>

			<div v-if="_.get(course, 'competences', []).length" class="col-sm text-md-right text-sm-left mb-3">
				<p class="font-weight-bold text-md-right text-sm-left">{{t('Competencies associated with this event:')}}</p>
				<span v-for="competence in course.competences" class="badge-cat">{{competence.category_name}}</span>
			</div>
		</div>

    <div v-if="isPath">
      <p class="font-weight-bold mb-2">{{ t('Events to complete the PATH') }}</p>
      <p class="p-14">{{ t('Choose 1 event from each box to complete the path.') }}</p>
      
      <div class="main-paths-container">
        <div v-for="path in course.pathways" :key="path">
          <div class="paths-container">
            <div class="path-container">
                <div class="path-image rounded-left" v-if="path.category.image" :style="{ 'background-image': `url('${path.category.image}')` }"></div>
                <div class="path-image rounded-left" v-else-if="path.category.asMainCourse.find(mc=>mc.course.course_image)" :style="{ 'background-image': `url('/index.php?r=course/getFile&courseid=${path.category.asMainCourse.find(mc=>mc.course.course_image).id_course}&file=${path.category.asMainCourse.find(mc=>mc.course.course_image).course.course_image}')` }"></div>
                <div class="path-image rounded-left" :style="{ 'background-image': linearGradient() }" v-else></div>
                <div class="path-info">
                    <div class="path-title font-weight-bold"><span>{{ path.unique_name||path.category.category_name }}</span>
                      <small v-if="_.some(path.category.asMainCourse, (mainCourse)=>(mainCourse.course.id_course_behavior && mainCourse.course.courseApplication.courseApplicationUser && mainCourse.course.courseApplication.courseApplicationUser.manager_date_approved) || (!mainCourse.course.id_course_behavior && !!mainCourse.course.coursePeople.length && !!mainCourse.course.coursePeople[0].completed))" style="background-color: rgb(0, 150, 136); color: rgb(255, 255, 255); padding: 5px 10px; display: inline-block; font-size: 0.75rem; cursor: pointer;" class="font-weight-bold rounded waves-effect waves-themed" @click="openChoose(path.category.asMainCourse.find(mc=>(mc.course.id_course_behavior && mc.course.courseApplication.courseApplicationUser && mc.course.courseApplication.courseApplicationUser.manager_date_approved) || (!mc.course.id_course_behavior && !!mc.course.coursePeople.length && !!mc.course.coursePeople[0].completed)).course)">{{ t('COMPLETED') }}</small>
                      <small v-else-if="_.some(path.category.asMainCourse, (mainCourse)=>(mainCourse.course.id_course_behavior && mainCourse.course.courseApplication.courseApplicationUser) || (!mainCourse.course.id_course_behavior && !!mainCourse.course.coursePeople.length && !mainCourse.course.coursePeople[0].completed))" style="background-color: rgb(252, 225, 38); color: rgb(38, 50, 56); padding: 5px 10px; display: inline-block; font-size: 0.75rem; cursor: pointer;" class="font-weight-bold rounded waves-effect waves-themed" @click="openChoose(path.category.asMainCourse.find(mc=>(mc.course.id_course_behavior && mc.course.courseApplication.courseApplicationUser) || (!mc.course.id_course_behavior && !!mc.course.coursePeople.length && !mc.course.coursePeople[0].completed)).course)">{{ t('IN-PROGRESS') }}</small>
                      <small v-else style="background-color: rgb(211, 47, 47); color: rgb(255, 255, 255); padding: 5px 10px; display: inline-block; font-size: 0.75rem; cursor: pointer;" class="font-weight-bold rounded waves-effect waves-themed" @click="let course = path.category.asMainCourse.find(mc=>(mc.course.id_course_behavior && !mc.course.courseApplication.courseApplicationUser) || (!mc.course.id_course_behavior && !mc.course.coursePeople.length)).course; course.id_course_behavior ? openCourse(course.id_course) : enroll(course.id_course)">{{ t('ENROLL') }}</small>
                    </div>
                    <div class="path-course-info"><!--span>{{ path.category.asMainCourse.length }} {{ t('Events') }}</span--><button type="button" class="btn btn-collapsed btn-link collapsed px-0" data-toggle="collapse" :data-target="`#courses-${path.id_category}`" aria-expanded="false" :aria-controls="`#courses-${path.id_category}`"><span class="add-icon">{{ t('View events options') }}</span><span class="less-icon">{{ t('Hide') }}</span> <AddIcon class="add-icon" height="20" width="20" /><LessIcon class="less-icon" height="20" width="20" /></button></div>
                </div>
            </div><!-- .path-container -->
        </div><!-- .paths-container -->
        <div class="path-courses-container collapse" :id="`courses-${path.id_category}`" v-if="path.category">
          <p class="font-weight-bold">{{ t('Choose 1 event that fits you and clic on it to register') }}</p>
            <div class="course-container pl-3 py-3 rounded" v-for="mainCourse in path.category.asMainCourse" :key="mainCourse">
                <div v-if="mainCourse.course.course_image" class="course-image rounded-left" :style="{ 'background-image': `url('/index.php?r=course/getFile&courseid=${mainCourse.id_course}&file=${mainCourse.course.course_image}')` }"></div>
                <div v-else class="course-image rounded-left" :style="{ 'background-image': linearGradient() }"></div>
                <div class="course-info">
                    <div class="course-title font-weight-bold"><a href="javascript:void" @click="mainCourse.course.id_course_behavior ? (mainCourse.course.courseApplication.courseApplicationUser ? openApp(mainCourse.course.courseApplication.courseApplicationUser.form_id_application) : openCourse(mainCourse.id_course)) : (!!mainCourse.course.coursePeople.length && !!mainCourse.course.coursePeople[0].completed) || (!!mainCourse.course.coursePeople.length && !mainCourse.course.coursePeople[0].completed) ? openCourse(mainCourse.id_course) : enroll(mainCourse.id_course)">{{ mainCourse.course.course_name }}</a>
                    <template v-if="mainCourse.course.id_course_behavior">
                      <small v-if="mainCourse.course.courseApplication.courseApplicationUser && mainCourse.course.courseApplication.courseApplicationUser.courseApplicationReviewers && mainCourse.course.courseApplication.courseApplicationUser.courseApplicationReviewers.date_approved" style="background-color: rgb(0, 150, 136); color: rgb(255, 255, 255); padding: 5px 12px; display: inline-block; font-size: 0.75rem; cursor: pointer;" class="font-weight-bold rounded waves-effect waves-themed" @click="openApp(mainCourse.course.courseApplication.courseApplicationUser.form_id_application)">{{ t('APPROVED') }}</small>
                      <small v-else-if="mainCourse.course.courseApplication.courseApplicationUser && mainCourse.course.courseApplication.courseApplicationUser.courseApplicationReviewers && mainCourse.course.courseApplication.courseApplicationUser.courseApplicationReviewers.date_disapproved" style="background-color: rgb(211, 47, 47); color: rgb(255, 255, 255); padding: 5px 12px; display: inline-block; font-size: 0.75rem; cursor: pointer;" class="font-weight-bold rounded waves-effect waves-themed" @click="openApp(mainCourse.course.courseApplication.courseApplicationUser.form_id_application)">{{ t('DENIED') }}</small>
                      <small v-else-if="mainCourse.course.courseApplication.courseApplicationUser" style="background-color: rgb(231, 106, 32); color: rgb(255, 255, 255); padding: 5px 12px; display: inline-block; font-size: 0.75rem; cursor: pointer;" class="font-weight-bold rounded waves-effect waves-themed" @click="openApp(mainCourse.course.courseApplication.courseApplicationUser.form_id_application)">{{ t('IN-PROGRESS') }}</small>
                      <small v-else style="background-color: rgb(211, 47, 47); color: rgb(255, 255, 255); padding: 5px 12px; display: inline-block; font-size: 0.75rem; cursor: pointer;" class="font-weight-bold rounded waves-effect waves-themed" @click="openCourse(mainCourse.id_course)">{{ t('ENROLL') }}</small>
                    </template>
                    <template v-else>
                      <small v-if="!!mainCourse.course.coursePeople.length && !!mainCourse.course.coursePeople[0].completed" style="background-color: rgb(0, 150, 136); color: rgb(255, 255, 255); padding: 5px 12px; display: inline-block; font-size: 0.75rem; cursor: pointer;" class="font-weight-bold rounded waves-effect waves-themed" @click="openCourse(mainCourse.id_course)">{{ t('COMPLETED') }}</small>
                      <small v-else-if="!!mainCourse.course.coursePeople.length && !mainCourse.course.coursePeople[0].completed" style="background-color: rgb(252, 225, 38); color: rgb(38, 50, 56); padding: 5px 12px; display: inline-block; font-size: 0.75rem; cursor: pointer;" class="font-weight-bold rounded waves-effect waves-themed" @click="openCourse(mainCourse.id_course)">{{ t('IN-PROGRESS') }}</small>
                      <small v-else style="background-color: rgb(211, 47, 47); color: rgb(255, 255, 255); padding: 5px 12px; display: inline-block; font-size: 0.75rem; cursor: pointer;" class="font-weight-bold rounded waves-effect waves-themed" @click="enroll(mainCourse.id_course)">{{ t('ENROLL') }}</small>
                    </template>
                        <!--small v-if="mainCourse.course.is_live === 1" style="background-color: #59AE8C; color: #FFFFFF; padding: 2px 4px; border-radius: 4px; display: inline-block; font-size: 0.75rem;">{{ t('LIVE') }}</small>
                        <small v-if="mainCourse.course.is_live === 0 && mainCourse.course.is_closed === 0" style="background-color: #00AEEF; color: #FFFFFF; padding: 2px 4px; border-radius: 4px; display: inline-block; font-size: 0.75rem;">{{ t('DRAFT') }}</small>
                        <small v-if="mainCourse.course.is_closed === 1" style="background-color: #9FA5AC; color: #FFFFFF; padding: 2px 4px; border-radius: 4px; display: inline-block; font-size: 0.75rem;">{{ t('ARCHIVED') }}</small-->
                    </div>
                    <div>
                        <OnlineIcon :color="'#263238'" v-if="mainCourse.course.course_type === 'online'" />
                        <OnsiteIcon :color="'#263238'" v-if="mainCourse.course.course_type === 'onsite'" />
                        <BlendedIcon :color="'#263238'" v-if="mainCourse.course.course_type === 'blended'" />
                        <span class="text-capitalize">{{ mainCourse.course.course_type }}</span> {{ t('event') }} <span v-if="mainCourse.course.course_start_date">| {{ mainCourse.course.course_start_hour ? mergeDateTime(mainCourse.course.course_start_date, mainCourse.course.course_start_hour) : mainCourse.course.course_start_date | formatDateApp(timezoneHelper(mainCourse.course)) }}</span></div>
                    <!--div><UserImg height="20" width="20" :color="'#263238'" /> {{ t('Speaker:') }}</div-->
                </div><!-- .course-info -->
            </div><!-- .course-container -->
            <div class="d-flex justify-content-center">
                <button type="button" class="btn btn-outline-primary btn-collapse" data-toggle="collapse" :data-target="`#courses-${path.id_category}`" aria-expanded="false" :aria-controls="`#courses-${path.id_category}`">{{ t('Close') }}</button>
            </div>
        </div><!-- .path-courses-container -->
        </div>
      </div><!-- main-paths.container -->
      
      <!-- CERTIFICATE -- >
      <div>
        <div><MedalIcon /> {{ t('CERTIFICATE') }}</div>

        <div class="certificate-container mt-3">
          <div class="certificate-image"></div>
          <div class="certificate-info">
            <p class="font-weight-bold">{{ course.course_name }}</p>
            <p class="p-14"><span class="certificate-valid">{{ t('VALID UNTIL:') }}</span></p>
          </div>
        </div>
      </div>
      <!-- /CERTIFICATE -->
    </div>


        <div class="row mt-5">
          <div class="col-md-12 text-center" :class="{ 'mb-5': isPath, }">
            <button v-if="showComingSoon" type="button" style="cursor: initial;" class="btn coming-soon-btn small m-xs-left">{{ t('Coming Soon') }}</button>
            <template v-else-if="isPath">
              <button type="button" class="btn btn-manage-event btn-path btn-outline-primary btn-block" @click="unfollowPath" v-if="course.course_people_data && !!course.course_people_data.pathway_enroll_type">{{ t('Unfollow') }}</button>
              <button class="btn btn-highlight btn-block" @click="!!course.courseEntityStructure ? showEnrollModal() : openFollowPath()" v-else>{{ t('Follow the Path') }}</button>
            </template>
            <button v-else-if="showEnroll && canEnrollByAllowedDomains"
                    :style="corporationStyles"
                    @click="trackEnrollClick"
                    v-bind:class="{'disabled': isEnrollDisabled}"
                    type="button" class="btn btn-big enroll-btn text-center">
              {{t('Enroll')}}
            </button>

            <button v-else-if="!canEnrollByAllowedDomains"
                    type="button" class="btn btn-big soldout m-xs-left disabled">
              {{t('Not allowed to Enroll')}}
            </button>

            <button v-else-if="showWaitList"
                    @click="addToWaitListOpen(course)"
                    type="button" class="btn btn-big waitlist m-xs-left">
              {{custom_waitlist_count && firstBttn ? firstBttn : t('Waitlist')}}
            </button>

            <button v-else-if="showWaitListFull"
            		@click=""
                    type="button" class="btn btn-big full small m-xs-left" >
              {{t('Full')}}
            </button>

            <button v-else-if="showWaitingWaitList"
            		@click="removeFromWaitList(course.id)"
                    type="button" class="btn btn-big waiting small m-xs-left" >
              {{custom_waitlist_count && secondBttn ? secondBttn : t('Waiting')}}
            </button>

            <button v-else-if="showSoldOut"
                    @click=""
                    :class="{'disabled': true}"
                    style="cursor: initial;"
                    type="button" class="btn soldout m-xs-left">
              {{t('Soldout')}}
            </button>

            <button v-else-if="showViewCourse && showRecertification"
                    @click="reCertification()"
                    :style="corporationStyles"
                    type="button" class="btn btn-big enroll-btn m-0-top-bottom m-0-left-right">
              {{t('Re-Certification')}}
            </button>

            <button v-else-if="showViewCourse"
                    @click=""

                          type="button" class="btn btn-light full-btn app-outline big mt-2 mb-1">

              <label v-if="course.course_type=='onsite'" class="no-btn mb-0" style="cursor: initial;">
              {{t('You are already')}}<br/>
              {{t('enrolled in this event.')}}</label>

              <label v-if="course.course_type!='onsite'" class="mb-0"><a :href="'index.php?r=courseModule&idCourse='+course.id">
              	{{t('View Content')}}</a></label>

            </button>

            	<p v-if="showViewCourse && isEnrollMultiple()" class="text-center"><a class="app-a" href="#" @click="isEnrollDisabled ? null : showEnrollModal()">
            		{{t('Enroll Others')}}</a></p>

          </div>
        </div>

          <div class="row d-none d-sm-block">
          <div v-if="corporationInfo.shareFacebook || corporationInfo.shareX || corporationInfo.shareEmail" class="col-md-12 text-center p-md-bottom">
            <div>
              <p class="text-center mb-1">{{t('Share')}}</p>

              <div v-if="corporationInfo.shareFacebook" class="fb-share-button"
                   data-href="http://nontraditional.apprendo.io/test"
                   data-layout="button" data-size="large" data-mobile-iframe="true">
                <a class="primary-color blue m-sm-right fb-xfbml-parse-ignore"
                   :href="'https://www.facebook.com/sharer/sharer.php?u=http://'+pagePath"
                   target="popup" onClick="window.open(this.href, this.target, 'width=350,height=420'); return false;">
                   <facebook-icon :height="32" :width="32" :iconColor="'#383838'"></facebook-icon>
                  
                </a>
              </div>
              <a v-if="corporationInfo.shareX" class="primary-color blue m-sm-right twitter-share-button"
                 :href="'https://x.com/intent/post?url=http://'+pagePath+'&text='+course.name" target="popup"
                 onClick="window.open(this.href, this.target, 'width=350,height=420'); return false;">
                 <twitterXIcon :height="32" :width="32" :iconColor="'#fff'" />
                
              </a>
              <a v-if="corporationInfo.shareEmail" :href="'mailto:?subject='+course.name+'&body=http://'+ pagePath" class="primary-color blue ml-1" target="_blank">
                <svg version="1.2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" overflow="visible" preserveAspectRatio="none" viewBox="0 0 30 30" width="30" height="30">
                <g transform="translate(0, 0)"><g transform="translate(0, 0) rotate(0)">
                  <path fill="rgb(37, 106, 179)" d="M30,15c0,8.28422 -6.71578,15 -15,15c-8.28422,0 -15,-6.71578 -15,-15c0,-8.28422 6.71578,-15 15,-15c8.28422,0 15,6.71578 15,15zM22,10.90909c0,-0.50182 -0.42,-0.90909 -0.9375,-0.90909h-13.125c-0.5175,0 -0.9375,0.40727 -0.9375,0.90909v8.18182c0,0.50182 0.42,0.90909 0.9375,0.90909h13.125c0.5175,0 0.9375,-0.40727 0.9375,-0.90909zM15.90953,16.41864l2.85,2.67227h-8.48531l2.85094,-2.69455l0.74063,0.71818c0.36656,0.355 0.95953,0.355 1.32562,0zM14.5,16.36364l-5.67609,-5.45455h11.39766zM12.43234,15.725l-3.52875,3.36591h-0.96609v-7.72455zM16.62437,15.725l4.43812,-4.30318v7.66909h-0.90891z" style="stroke: rgb(140, 140, 140); stroke-width: 0; stroke-linecap: butt; stroke-linejoin: miter; " vector-effect="non-scaling-stroke"/></g><defs>
                    <path id="path-163147624106428610" d="M30,15c0,8.28422 -6.71578,15 -15,15c-8.28422,0 -15,-6.71578 -15,-15c0,-8.28422 6.71578,-15 15,-15c8.28422,0 15,6.71578 15,15zM22,10.90909c0,-0.50182 -0.42,-0.90909 -0.9375,-0.90909h-13.125c-0.5175,0 -0.9375,0.40727 -0.9375,0.90909v8.18182c0,0.50182 0.42,0.90909 0.9375,0.90909h13.125c0.5175,0 0.9375,-0.40727 0.9375,-0.90909zM15.90953,16.41864l2.85,2.67227h-8.48531l2.85094,-2.69455l0.74063,0.71818c0.36656,0.355 0.95953,0.355 1.32562,0zM14.5,16.36364l-5.67609,-5.45455h11.39766zM12.43234,15.725l-3.52875,3.36591h-0.96609v-7.72455zM16.62437,15.725l4.43812,-4.30318v7.66909h-0.90891z" vector-effect="non-scaling-stroke"/></defs></g>
                </svg>
              </a>
            </div>
          </div>
        </div>


        <div class="row m-md-top d-block d-sm-none">
          <div class="col-12 text-center p-xs-bottom">
            <label style="font-weight: normal;" class="m-sm-left">{{t('Share')}}</label>
          </div>

          <div v-if="corporationInfo.shareFacebook || corporationInfo.shareX || corporationInfo.shareEmail" class="col-12 text-center p-md-bottom">
            <div v-if="corporationInfo.shareFacebook" class="fb-share-button"
                 data-href="http://nontraditional.apprendo.io/test"
                 data-layout="button" data-size="large" data-mobile-iframe="true">
              <a class="primary-color blue m-sm-right fb-xfbml-parse-ignore"
                 :href="'https://www.facebook.com/sharer/sharer.php?u=http://'+pagePath"
                 target="popup" onClick="window.open(this.href, this.target, 'width=350,height=420'); return false;">
                 <facebook-icon :height="32" :width="32" :iconColor="'#383838'"></facebook-icon>
              </a>
            </div>
            <a v-if="corporationInfo.shareX" class="primary-color blue m-sm-right twitter-share-button"
               :href="'https://x.com/intent/post?url=http://'+pagePath+'&text='+course.name" target="popup"
               onClick="window.open(this.href, this.target, 'width=350,height=420'); return false;">
              <twitterXIcon :height="32" :width="32" :iconColor="'#fff'" />
            </a>
            <a v-if="corporationInfo.shareEmail" :href="'mailto:?subject='+course.name+'&body=http://'+ pagePath" class="primary-color blue ml-1" target="_blank">
              <svg version="1.2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" overflow="visible" preserveAspectRatio="none" viewBox="0 0 30 30" width="30" height="30">
                <g transform="translate(0, 0)"><g transform="translate(0, 0) rotate(0)">
                  <path fill="rgb(37, 106, 179)" d="M30,15c0,8.28422 -6.71578,15 -15,15c-8.28422,0 -15,-6.71578 -15,-15c0,-8.28422 6.71578,-15 15,-15c8.28422,0 15,6.71578 15,15zM22,10.90909c0,-0.50182 -0.42,-0.90909 -0.9375,-0.90909h-13.125c-0.5175,0 -0.9375,0.40727 -0.9375,0.90909v8.18182c0,0.50182 0.42,0.90909 0.9375,0.90909h13.125c0.5175,0 0.9375,-0.40727 0.9375,-0.90909zM15.90953,16.41864l2.85,2.67227h-8.48531l2.85094,-2.69455l0.74063,0.71818c0.36656,0.355 0.95953,0.355 1.32562,0zM14.5,16.36364l-5.67609,-5.45455h11.39766zM12.43234,15.725l-3.52875,3.36591h-0.96609v-7.72455zM16.62437,15.725l4.43812,-4.30318v7.66909h-0.90891z" style="stroke: rgb(140, 140, 140); stroke-width: 0; stroke-linecap: butt; stroke-linejoin: miter; " vector-effect="non-scaling-stroke"/></g><defs>
                    <path id="path-163147624106428610" d="M30,15c0,8.28422 -6.71578,15 -15,15c-8.28422,0 -15,-6.71578 -15,-15c0,-8.28422 6.71578,-15 15,-15c8.28422,0 15,6.71578 15,15zM22,10.90909c0,-0.50182 -0.42,-0.90909 -0.9375,-0.90909h-13.125c-0.5175,0 -0.9375,0.40727 -0.9375,0.90909v8.18182c0,0.50182 0.42,0.90909 0.9375,0.90909h13.125c0.5175,0 0.9375,-0.40727 0.9375,-0.90909zM15.90953,16.41864l2.85,2.67227h-8.48531l2.85094,-2.69455l0.74063,0.71818c0.36656,0.355 0.95953,0.355 1.32562,0zM14.5,16.36364l-5.67609,-5.45455h11.39766zM12.43234,15.725l-3.52875,3.36591h-0.96609v-7.72455zM16.62437,15.725l4.43812,-4.30318v7.66909h-0.90891z" vector-effect="non-scaling-stroke"/></defs></g>
                </svg>
            </a>
          </div>
        </div>


      </section>
     <!-- <div class="container courses-slider-container p-5 mt-5" v-if="showImagesSlider" style="background-color:#e9e9e9;">
          <div class="">
            <b><h5 class="m-0-bottom font-weight-bold you-may pl-3">
            	{{t('You may also like')}}</h5></b>
          </div>


        <courses-slider v-if="showImagesSlider"
                        :corporation="corporation"
                        @enroll="enroll"
                        @wait-list="addToWaitList"
                        :courses-list="courses">
        </courses-slider>
        </div>-->

      </template><!-- /SHOW COURSE ALTERNATIVE CONTENT -->

      <list-footer></list-footer>
      <!--
      <course-footer></course-footer>
      -->
      <!-- first name validation -->
      <md-dialog
              :md-active.sync="showModal"
              :md-click-outside-to-close="false"
               class="modal-apply-application">
              <div class="modal-content" style="background-color: #F5F6F8;">
                <div class="modal-body p-4">
                <div class="app-info d-flex flex-column">
                  <div class="d-flex justify-content-center pb-4 pt-3"><SeatComputerIcon /></div>
                    <div class="col-md-12">

                            <h2 class="title" style="text-align: center;">{{t('Please provide your full name')}}</h2>
                             <p style="text-align: center;font-size: 16px;">{{ t('Complete the following field to continue.') }}</p>
                    </div>
                        </div>
                <div class="row">
                                <div class="col-md-12">
                  <input class="ng-element el-input-without-label interactive font-G-adqqawk3cmg56rbeecg50wkf-n4"  @keyup.enter="setFirstName" autocomplete="none" spellcheck="false" type="text" 
                  v-bind:placeholder="t('Enter your full name here')" v-model="userFirstName" style="opacity: 1; mix-blend-mode: normal; background-color: rgb(255, 255, 255); border-color: rgb(37, 106, 179); border-width: 1px; color: rgb(56, 56, 56); padding: 0px 8px; text-align: center; border-radius: 4px; font-size: 16px; font-weight: normal; font-style: normal; background-image: none; background-position: center center; background-repeat: repeat; background-size: cover; border-style: solid; width: 480px; height: 48px;">
                                </div></div>
                  <p></p><br/>
                   <div class="app-actions">

                    <button v-if="!showLoader" @click="setFirstName" type="button" class="mt-2 mb-3" v-bind:class="{'disabledFirstName': validationFullName() == false, 'enableFirstName': validationFullName() == true}"
                                       :disabled="validationFullName() == false">
                                    {{t('Save and continue')}}
                                </button>

                   </div>
                </div>
              </div>
      </md-dialog>
      <!-- first name validation -->
      <!-- init seats model -->
          <!-- Single Seat dialog -->
          <md-dialog
            :md-active.sync="showDialog"
            class="select-seats modal-dialog"           
            :md-click-outside-to-close="false"
          >
            <div class="modal-content" v-if="!mustAskForTeamMode">
              <div class="modal-body" style="padding: 30px;">
                <button
                  type="button"
                  class="close close-modal pull-right"
                  style="color: #256ab3"
                  @click="goBack();"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <svg
                    width="15px"
                    height="15px"
                    viewBox="0 0 15 15"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <g
                      id="Checkout"
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <g
                        id="2.1-Multiple-Seats-/already-enrolled"
                        transform="translate(-947.000000, -225.000000)"
                        fill="#256AB3"
                      >
                        <g id="Group">
                          <g
                            id="close"
                            transform="translate(947.000000, 225.000000)"
                          >
                            <g id="uikit/input/icon/close/out">
                              <g id="close">
                                <path
                                  d="M8.51721934,7.49988014 L14.7890531,1.22804634 C15.069996,0.947103476 15.069996,0.49165002 14.7890531,0.210707151 C14.5081103,-0.0702357171 14.0526568,-0.0702357171 13.7717139,0.210707151 L7.49988014,6.48254095 L1.22804634,0.211666001 C0.947103476,-0.0692768678 0.49165002,-0.0692768678 0.210707151,0.211666001 C-0.0702357171,0.492608869 -0.0702357171,0.948062325 0.210707151,1.22900519 L6.48254095,7.50083899 L0.211666001,13.7717139 C-0.0692768678,14.0526568 -0.0692768678,14.5081103 0.211666001,14.7890531 C0.35261686,14.9290451 0.535757091,15 0.719856173,15 C0.903955254,15 1.08805433,14.930004 1.22804634,14.7890531 L7.49988014,8.51721934 L13.7717139,14.7890531 C13.9126648,14.9290451 14.095805,15 14.2799041,15 C14.4640032,15 14.6481023,14.930004 14.7880943,14.7890531 C15.0690372,14.5081103 15.0690372,14.0526568 14.7880943,13.7717139 L8.51721934,7.49988014 Z"
                                  id="Shape"
                                  fill-rule="nonzero"
                                />
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                </button>
                <div class="row">
                  <div class="col-12 pr-0">
                    <h2 class="d-block d-sm-none mb-5 select-seats">
                      {{ course.course_name }}
                    </h2>
                    <label class="d-block d-sm-none select-seats">
                      {{ t("Select a Seats") }}
                    </label>
                    <h3 class="d-none d-sm-block m-lg-bottom">
                      {{ t("Select Seats") }}
                    </h3>
                    <div class="el-rich-text__content el-rich-text__content--valign-top"><p>{{t("There are no more seats available. Please click on the waitlist button of your preferred seat.")}}</p></div>
                    
                    <!-- Desktop version -->
                    <apprendo-table class="mt-2 d-none d-sm-block" id="tableSelect">
                      <thead>
                        <tr class="d-none d-sm-table-row">
                          <th style="width: 60%">{{ t("Seats Type") }}</th>
                          <th class="text-left">{{ t("Price") }}</th>
                          <th class="text-center">{{ t("Quantity") }}</th>
                        </tr>
                      </thead>
                      <tbody >
                        <tr v-for="(seat, index) in seats" 
                          v-bind:key="index"                         
                          style="cursor: pointer;">
                          <td>
                            <!-- <md-radio :id="'idradio-'+index"  v-if="seat.capacity > seat.capacity_taken && !isRestricted(seat)" v-model="singleSelectedSeat" class="md-primary" name="radiobutton"
                                :value="seat"></md-radio> -->
                            <span style="vertical-align: super;">{{
                              seat.name
                            }}</span>
                            <!-- Description and course date -->
                            <small style="display: block; color: #ababab;">
                              <span v-if="seat.description"
                                >{{ seat.description }}.</span
                              >
                            </small>
                          </td>
                          <td>${{ seat.price }}</td>
                          <td class="nowrap text-center">
                            <!-- <div v-if="seat.capacity > seat.capacity_taken && !isRestricted(seat)">
                              {{
                                _.get(
                                  singleSelectedSeat,
                                  "id_course_seat",
                                  null
                                ) === seat.id_course_seat
                                  ? 1
                                  : 0
                              }}
                            </div> -->
                            <!-- Waitlist button or sold out -->
                             <span v-if="isRestricted(seat)">
                                  <div class="restricted-label">{{ t('RESTRICTED') }} <InfoIcon :id="`restricted_info_s${index}`" /></div>
                            </span>
                            <span v-else>
                              <div                               
                                class="text-center"
                              >
                                <button
                                  @click.stop.prevent="
                                    btnShowWaitListModal(seat);
                                  "
                                  class="btn"
                                  :class="{ 'btn-outline-primary': isWaitlistSeat(seat), 'enroll-btn reset-enroll-btn': !isWaitlistSeat(seat), }"
                                >
                                  {{
                                    isWaitlistSeat(seat) ? seat.custom_waitlist && seat.custom_waitlist_1 ? seat.custom_waitlist_1 : t("Waitlist") : t('Enroll')
                                  }}
                                </button>
                              </div>   
                              </span>
                            <b-tooltip
                              v-if="isRestricted(seat)"
                              class="tooltip1"
                              :show="false"
                              :target="`restricted_info_s${index}`"
                              placement="bottom"
                              >{{ t('Only for special domains') }}</b-tooltip>
                          </td>
                        </tr>
                      </tbody>
                    </apprendo-table>

                    <!-- <div class="d-none d-sm-block apprendo-table mt-2">
                      <table class="totals-section py-2 mx-0" style="width: 100%;">
                        <tbody>
                          <tr>
                            <td style="width: 60%; padding:25px;">
                              <label class="m-0 font-weight-bold">
                                {{ t("Total Purchase") }}
                              </label>
                            </td>
                            <td class="text-left" style="padding:25px;">
                              <label class="m-0 font-weight-bold"
                                >${{ _.get(singleSelectedSeat, "price", 0) }}</label
                              >
                            </td>
                            <td class="text-right" style="padding:25px;">
                              <label class="m-0 font-weight-bold">
                                {{ singleSelectedSeat ? 1 : 0 }} {{ t("seat") }}
                              </label>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div> -->

                    <div v-if="totalSeatsAvailable == 0">
                      <p style="color:#D95A4B;text-align:center;">
                        {{ totalSeatsInProcessAvailable == 0 ? t('We are sorry, other users in the waitlist have taken the available seats') : t('Please try again later, some users are deciding to purchase the last available seats.') }}
                      </p>
                    </div>
                    <!-- End desktop version -->

                    <!-- Mobile single seat version -->
                    <div
                      v-for="(seat, index) in seats"
                      v-bind:key="seat"
                      :class="{ top: index === 0 }"
                      class="d-block d-sm-none seat-section px-3 py-3"
                    >
                      <div class="row"                        
                        style="cursor: pointer;">
                        <div class="col-12 pb-3">
                          <md-radio
                            :id="'radio-'+index"  
                            v-if="seat.capacity > seat.capacity_taken && !isRestricted(seat)"
                            v-model="singleSelectedSeat"
                            class="md-primary"
                            name="radiobutton"
                            :value="seat"
                          ></md-radio>
                          <span>{{ seat.name }}</span>
                          <!-- Description and course date -->
                          <small style="display: block; color: #ababab;">
                            <span v-if="seat.description"
                              >{{ seat.description }}.</span
                            >
                          </small>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-6">${{ seat.price }}</div>
                        <div class="col-6 text-right">
                          <div v-if="seat.capacity > seat.capacity_taken && !isRestricted(seat)">
                            {{
                              _.get(singleSelectedSeat, "id_course_seat", null) ===
                              seat.id_course_seat
                                ? 1
                                : 0
                            }}
                            {{ t("seat") }}
                          </div>

                          <!-- Waitlist button or sold out -->
                          <span v-if="isRestricted(seat)">
                            <div class="restricted-label">{{ t('RESTRICTED') }} <InfoIcon :id="`restricted_info_ss${index}`" /></div>                       
                          </span>
                          <span v-else-if="isRestricted(seat)">
                             <div v-if="validateEnabledWaitlist" class="text-center">
                               <button
                                  @click.stop.prevent="
                                    btnShowWaitListModal(seat);
                                  "
                                  class="btn btn-outline-primary"
                                >
                                  {{
                                    seat.custom_waitlist && seat.custom_waitlist_1 ? seat.custom_waitlist_1 : t("Waitlist")
                                  }}
                                </button>                             
                            </div>    
                          </span>
                            <b-tooltip
                              v-if="isRestricted(seat)"
                              class="tooltip1"
                              :show="false"
                              :target="`restricted_info_ss${index}`"
                              placement="bottom"
                              >{{ t('Only for special domains') }}</b-tooltip>
                        </div>
                      </div>
                    </div>

                    <div class="row totals-section py-2 mx-0 d-block d-sm-none">
                      <div class="col-12">
                        <label class="m-0 font-weight-bold">
                          {{ t("Total Purchase") }}
                        </label>
                      </div>
                      <div class="row" style="margin: 0;">
                        <div class="col-6 text-left">
                          <label class="m-0 font-weight-bold"
                            >${{ _.get(singleSelectedSeat, "price", 0) }}</label
                          >
                        </div>
                        <div class="col-6 text-right">
                          <label class="m-0 font-weight-bold"
                            >{{ singleSelectedSeat ? 1 : 0 }} {{ t("seat") }}</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Mobile single seat version -->

                <!-- Actions -->
                <md-dialog-actions
                  class="text-center m-lg-top"
                  v-if="totalSeatsAvailable > 0"
                >
                  <apprendo-btn
                    class="mx-auto"
                    :disabled="!singleSelectedSeat"
                    @click="closeSingleEnrollModal();"
                    name="test_anchor_confirm_seat"
                    >{{ t("Continue with the checkout") }}</apprendo-btn
                  >
                </md-dialog-actions>

                <md-dialog-actions
                  class="ext-center m-lg-top"
                  v-if="totalSeatsAvailable == 0"
                >
                  <apprendo-btn class="mx-auto" :disabled="!selectedSeats.length">
                    <a
                      style="color: white; text-decoration: none;"
                      href="/marketplace/list"
                      >{{ t("Go back to the catalogue") }}</a
                    >
                  </apprendo-btn>
                </md-dialog-actions>
              </div>
            </div>
          </md-dialog>
          <!-- End single seat dialog -->
      <!-- fin seats models -->
      <!-- init wailist modal -->
         <md-dialog :md-active.sync="openDialog"
               class="modal-dialog sign-up email-preview">
        <md-dialog-content v-if="seatSelected" style="padding: 0;">
        <!--div class="modal-content" v-if="seatSelected"-->
            <div class="modal-body" style="margin-bottom: 82px;">
                <div class="row">
                    <div class="col-12 text-right" style="cursor: pointer" v-on:click="openDialog = false">
                        <close-icon class="close-btn" v-on:click="openDialog = false"
                                    width="15" height="15"></close-icon>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12 text-center">
                        <svg width="227" height="113" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        	<defs><path id="a" d="M138 9.525L0 9.742 9.665.413 128.56.196z"/>
                        	<path d="M17.933 2.614C17.933 3.93 13.95 5 9.036 5 4.12 5 .138 3.931.138 2.614.138 1.296 4.12.227 9.036.227" id="c"/>
                        	<path id="e" d="M0 112h171V0H0z"/></defs>
                        	<g fill="none" fill-rule="evenodd"><g transform="translate(27 1)"><g transform="translate(0 97)">
                        	<mask id="b" fill="#fff"><use xlink:href="#a"/></mask>
                        	<path fill="#E9E9E9" mask="url(#b)" d="M138 9.525L0 9.742 9.665.413 128.56.196z"/></g>
                        	<path d="M11 72.028v23.887L3 106V76.805s8-5.232 8-4.777" fill="#F5C900"/>
                        	<path d="M11 72.028v23.887L3 106V76.805s8-5.232 8-4.777" fill="#F0894F"/>
                        	<path d="M11 73.022L10.199 73C8.174 74.066 3 77.383 3 77.383V106l.576-.713C4.522 100.326 7.07 89.463 11 81.941v-8.92z" fill="#FFB100"/>
                        	<path d="M128 72.026v24.021l8 9.953V77.19s-8-5.614-8-5.164" fill="#F5C900"/><path d="M128 72.026v24.021l8 9.953V77.19s-8-5.614-8-5.164" fill="#F0894F"/>
                        	<path d="M128 81.507c1.266 3.175 5.775 14.864 6.946 23.144L136 106V76.372s-.192-.14-.518-.372L128 80.482v1.025z" fill="#FFB100"/><path fill="#F5C900" d="M0 78l9.937-6H128.44L138 78H.15"/>
                        	<path fill="#F0894F" d="M0 78l9.937-6H128.44L138 78H.15"/><path fill="#FFE848" d="M0 77v29h2.71V81.52h132.58V106H138V77z"/>
                        	<path fill="#F3A93B" d="M8 73.227h122l-.82-.454H8.852zM133 75.227l-.823-.454H4.855L4 75.227z"/>
                        	<g transform="translate(144 107)"><mask id="d" fill="#fff"><use xlink:href="#c"/></mask>
                        	<path d="M17.933 2.614C17.933 3.93 13.95 5 9.036 5 4.12 5 .138 3.931.138 2.614.138 1.296 4.12.227 9.036.227c4.913 0 8.897 1.069 8.897 2.387" fill="#E9E9E9" mask="url(#d)"/></g>
                        	<mask id="f" fill="#fff"><use xlink:href="#e"/></mask><path fill="#F0894F" mask="url(#f)" d="M152 109h3V34h-3z"/>
                        	<path fill="#E9693E" mask="url(#f)" d="M152 37h3v-3h-3z"/><path fill="#FFB100" mask="url(#f)" d="M154 109h1V34h-1z"/>
                        	<path d="M171 17.5c0 9.665-7.835 17.5-17.5 17.5S136 27.165 136 17.5 143.835 0 153.5 0 171 7.835 171 17.5" fill="#345CD7" mask="url(#f)"/>
                        	<path d="M170 17.5c0 9.113-7.387 16.5-16.5 16.5S137 26.613 137 17.5 144.387 1 153.5 1 170 8.387 170 17.5" fill="#FFF" mask="url(#f)"/>
                        	<path d="M169 17.5c0 8.56-6.94 15.5-15.5 15.5-8.56 0-15.5-6.94-15.5-15.5C138 8.94 144.94 2 153.5 2c8.56 0 15.5 6.94 15.5 15.5" fill="#345CD7" mask="url(#f)"/></g>
                        	<path d="M189.538 11.92a.43.43 0 0 0-.309-.132h-1.396v-1.381a.444.444 0 0 0-.436-.452h-.46c-3.279 0-5.2.492-6.438 1.683-1.239-1.19-3.16-1.683-6.438-1.683h-.458a.444.444 0 0 0-.436.452v1.381h-1.397a.424.424 0 0 0-.31.132.462.462 0 0 0-.127.32l.006 11.93c0 .25.196.451.437.451h.546c5.874 0 7.123 1.511 7.247 1.67a.435.435 0 0 0 .338.164h1.185a.435.435 0 0 0 .339-.165c.123-.158 1.38-1.669 7.253-1.669h.546a.444.444 0 0 0 .437-.451V12.24a.466.466 0 0 0-.13-.32zM172.25 23.705v-11h.917v11c-.165-.004-.47-.004-.917 0zm1.833.165V10.87c3.19 0 4.93.455 5.98 1.591l-.021 13.076c-.578-.55-1.97-1.476-5.959-1.668zm6.854 1.65V12.462c1.05-1.136 2.79-1.59 5.98-1.59v12.833c-3.99.192-5.402 1.265-5.98 1.815zm7.813-1.815a34.92 34.92 0 0 0-.917 0v-11h.917v11z" fill="#FFF"/><path d="M24.177 42.743C21.87 42.743 20 40.86 20 38.538s1.87-4.205 4.177-4.205c2.307 0 4.177 1.883 4.177 4.205s-1.87 4.205-4.177 4.205zm0-1.53a2.667 2.667 0 0 0 2.658-2.675 2.667 2.667 0 0 0-2.658-2.676 2.667 2.667 0 0 0-2.658 2.676 2.667 2.667 0 0 0 2.658 2.676zM49.578 19.41c-2.307 0-4.177-1.883-4.177-4.205S47.271 11 49.578 11c2.307 0 4.177 1.883 4.177 4.205s-1.87 4.205-4.177 4.205zm0-1.53a2.667 2.667 0 0 0 2.658-2.675 2.667 2.667 0 0 0-2.658-2.676 2.667 2.667 0 0 0-2.658 2.676 2.667 2.667 0 0 0 2.658 2.676zM128.177 8.41C125.87 8.41 124 6.527 124 4.205S125.87 0 128.177 0c2.307 0 4.177 1.883 4.177 4.205s-1.87 4.205-4.177 4.205zm0-1.53a2.667 2.667 0 0 0 2.658-2.675 2.667 2.667 0 0 0-2.658-2.676 2.667 2.667 0 0 0-2.658 2.676 2.667 2.667 0 0 0 2.658 2.676zM208.177 83.243c-2.307 0-4.177-1.883-4.177-4.205s1.87-4.205 4.177-4.205c2.307 0 4.177 1.883 4.177 4.205s-1.87 4.205-4.177 4.205zm0-1.53a2.667 2.667 0 0 0 2.658-2.675 2.667 2.667 0 0 0-2.658-2.676 2.667 2.667 0 0 0-2.658 2.676 2.667 2.667 0 0 0 2.658 2.676z" fill="#F3A93C" fill-rule="nonzero"/><g stroke="#00C59D" stroke-linecap="round" stroke-linejoin="bevel" stroke-width="2"><path d="M6.472 73.832l.1 3.351M5.11 78.913l-3.586.024M6.597 80.818l-.025 3.353M12.28 78.867l-3.586.023"/></g><g stroke="#00C59D" stroke-linecap="round" stroke-linejoin="bevel" stroke-width="2"><path d="M86.472 15.832l.1 3.351M85.11 20.913l-3.586.024M86.597 22.818l-.025 3.353M92.28 20.867l-3.586.023"/></g><g stroke="#00C59D" stroke-linecap="round" stroke-linejoin="bevel" stroke-width="2"><path d="M219.59 21.165l.1 3.351M218.227 26.247l-3.586.023M219.714 28.152l-.025 3.352M225.397 26.2l-3.585.023"/>
                        	</g></g>
                        </svg>
                        <h3 class="mt-5">
                            <span v-if="seatSelected.custom_waitlist && seatSelected.custom_waitlist_2">{{seatSelected.custom_waitlist_2}}</span>
                            <span v-else>{{t('Do you want to be')}}<br>
                            {{t('added to the waitlist?')}}</span></h3>

                        <div v-if="!message" class="mt-4 text-center">
                            <p class="mx-0 my-0">
                              <span v-if="seatSelected.custom_waitlist && seatSelected.custom_waitlist_3">{{seatSelected.custom_waitlist_3}}</span>
                              <span v-else>{{t('If you add yourself to the waitlist (' + (seatSelected ? seatSelected.name : '') + '), we will contact you')}}<br>
                              {{t('via email if a space becomes available.')}}</span>
                            </p>
                        </div>
                        <div v-else v-html="$sanitize(message)" class="mt-4 text-center fr-view"></div>
                    </div>
                </div>
            </div>
            <div class="modal-footer d-flex justify-content-between" style="background-color: var(--md-theme-default-background,#fff) !important;">
              <button  v-on:click="openDialog = false" class="btn btn-outline-primary cancel">{{t('Cancel')}}</button>
              <button v-on:click="addToWaitList(course.id,seatSelected.id_course_seat_type,seatSelected.id_course_seat,seatSelected.name); openDialog = false" class="btn btn-primary">{{seatSelected.custom_waitlist && seatSelected.custom_waitlist_4 ? seatSelected.custom_waitlist_4 : t('Yes, add me to the waitlist')}}</button>
            </div>
        </md-dialog-content>
        <!--/div-->
    </md-dialog>
      <!-- fin wailist modal -->
    </template>
  </div>
</template>

<script>
import DOMPurify from 'dompurify';
import twitterIcon from '@/components/Icons/twitterIcon';

import API from '@/api/index';
import MainHeader from '@/components/layout/MainHeader';
import CourseFooter from '@/components/layout/CourseFooter';
import SessionManageMixin from '@/mixins/SessionManageMixin';

import LoginModal from '@/components/layout/LoginModal';
import CourseEnrollModal from '@/components/CourseEnrollModal';
import TabsPanel from './components/TabsPanel';
import CourseImagesCarousel from './components/CourseImagesCarousel';
import LocationMap from './components/LocationMap';

import CoursesSlider from './components/CoursesSlider';
import LocationIcon from "@/components/Icons/LocationIcon";
import CourseTypeIcon from "@/components/Icons/CourseTypeIcon";
import BetaBanner from '@/mixins/BetaBanner';
import PlayAloudText from '@/components/PlayAloudText';
import WaitListModal from '@/components/WaitListModal';
import ListFooter from '@/components/layout/ListFooter';

import WaitListRemoveModal from '@/components/WaitListRemove';

import EnrollBtnUtils from '@/mixins/EnrollBtnUtils';
import MixinSearch from '@/mixins/MixinSearch';
import DoorPlanetsIcon from '@/components/Icons/DoorPlanetsIcon';
import HeartReactionIcon from '@/components/Icons/HeartReactionIcon';
import CloseIcon from '@/components/Icons/CloseIcon';
import RegistrationIcon from '@/components/Icons/RegistrationIcon';
import FacebookSimple from '@/components/Icons/FacebookSimple';
import TwitterSimple from '@/components/Icons/TwitterSimple';
import EnvelopeSimple from '@/components/Icons/EnvelopeSimple';
import SeatComputerIcon from '@/components/Icons/SeatComputerIcon';
import BlendedIcon from '@/components/Icons/BlendedIcon';
import CourseIcon from '@/components/Icons/CourseIcon';
import RewardIcon from '@/components/Icons/RewardIcon';
import ClickIcon from '@/components/Icons/ClickIcon';
import {  mapState, mapMutations, mapActions } from "vuex";
import {getRootCssCorporation} from '@/utils/common.js';
import ApprendoTable from "@/components/ApprendoTable";
import { PAGES, } from '@/utils/index';
import FormattingMixin from '@/mixins/FormattingMixin';
import AddIcon from "@/components/Icons/AddIcon";
import LessIcon from "@/components/Icons/LessIcon";
import MedalIcon from "@/components/Icons/MedalIcon";
import TimeAlmostOutIcon from "@/components/Icons/TimeAlmostOutIcon";
import ArtWorking from "@/components/Icons/ArtWorking";

import WorldIcon from '@/components/Icons/WorldIcon';
import facebookIcon from '@/components/Icons/facebookIcon';
import linkedinIcon from '@/components/Icons/linkedinIcon';
import youtubeIcon from '@/components/Icons/youtubeIcon';
import instagramIcon from '@/components/Icons/instagramIcon';
import twitterXIcon from '@/components/Icons/twitterXIcon';
import pinterestIcon from '@/components/Icons/pinterestIcon';
import LocationBIcon from "@/components/Icons/LocationBIcon";
import DateIcon from "@/components/Icons/DateIcon";

export default {
    mixins: [
      SessionManageMixin,
      BetaBanner,
      EnrollBtnUtils,
      MixinSearch,
      FormattingMixin,
    ],
    components: {
      PlayAloudText,
      CourseTypeIcon,
      LocationIcon,
      MainHeader,
      CourseEnrollModal,
      LoginModal,
      CourseFooter,
      ListFooter,
      TabsPanel,
      CourseImagesCarousel,
      LocationMap,
      CoursesSlider,
      WaitListModal,
      WaitListRemoveModal,
      DoorPlanetsIcon,
      HeartReactionIcon,
      CloseIcon,
      RegistrationIcon,
      FacebookSimple,
      TwitterSimple,
      EnvelopeSimple,
      ClickIcon,
      SeatComputerIcon,
      twitterIcon,
      ApprendoTable,
      BlendedIcon,
      CourseIcon,
      RewardIcon,
      AddIcon,
      LessIcon,
      MedalIcon,
      TimeAlmostOutIcon,
      ArtWorking,
      WorldIcon,
      facebookIcon,
      linkedinIcon,
      youtubeIcon,
      instagramIcon,
      twitterXIcon,
      pinterestIcon,
      LocationBIcon,
      DateIcon,
    },
    data() {
        return {
            tabIndex: 0,
            courses: [],
            requisites: [],
            course: {},
            showMobileHeader: false,
            expandGoToSection: false,
            openWaitListModal: false,
            openWaitListRemoveModal: false,
            schedule: [],
            pagePath: window.DOMAIN + window.location.pathname,
            courseNewManagers: [],
            mustTriggerEnroll : false,
            allowed_domains: ALLOWED_DOMAINS, //to avoid attacks this value is set here
            showAddedFavoritesModal: false,
            courseLoaded: false,
            applyAppModal: false,
            applyingApp: false,
            pendingStartApplication: false,
            pendingApplyAppModal: false,
            showFirstNametModal : false,
            userFirstName: '',
            userData: {},
            tryNewApplication: false,
            validatingApplied: false,
            showDialog: false,
            singleSelectedSeat: null,
            seatSelected: null,
            openDialogProp: false,
            openDialog: false,
            showModal: false,
            launching: false,    
            showRecertificationEnabled:ENABLE_RECERTIFICATION=='1'?true:false,
            showUnfollowModal: false,
            showfollowModal: false,
            pendingShowfollowModal: false,
            // Performance Plan data
            performancePlanModal: false,
            startingPlan: false,
            myPerformancePlans: [],
            selectedPlanYear: new Date().getFullYear(),
            loadingMyPlans: false,
        }
    },
    watch: {
      hasLike: function(val) {
        if(val && this.courseLoaded) { this.showAddedFavoritesModal = true; }
      },
      isLoggedIn: function(val) {
        if(val && this.pendingStartApplication) {
          this.pendingStartApplication = false;
          this.applyAppModal = true;
          this.doStartApplication();
        }
        if(val && this.pendingApplyAppModal) {
          this.pendingApplyAppModal = false;
          this.applyAppModal = true;
        }

        if(val && this.pendingShowfollowModal) {
          this.pendingShowfollowModal = false;
          this.showfollowModal = true;
        }
        this.doLaunch();
      },
      corporation() {
        getRootCssCorporation(this.corporation.id);
        this.doLaunch();
      },
    },
    computed: {
      ...mapState(['isLoggedIn', 'user', 'hasEnroll', 'corporationInfo']),
        _() {
            return _;
        },
        // showModal(){
        //   let _userinfo = this.user;
        //   if(this.isLoggedIn && _userinfo && _userinfo.first_name && _userinfo.last_name && (_userinfo.first_name.toUpperCase() + _userinfo.last_name.toUpperCase()) == 'YOURNAME'){
        //         return true;
        //   }
        //   return false;
        // },
        async userData(){
          if(this.user){
            const response = await API.domain.crudDataUser({
                body: {
                  id_user : this.user.id
                }
              });

              this.userData = response.data.User;
          }
        },
        isDraft() {
          return _.get(this.course, 'is_live', 0) == 0 && _.get(this.course, 'is_closed', 0) == 0;
        },
        isArchived() {
          return _.get(this.course, 'is_live', 0) == 0 && _.get(this.course, 'is_closed', 0) == 1;
        },
        isOwnerOrCM() {
          return _.get(this.user, "ACL.Course.Create", 0) === 1 && (_.get(this.user, 'level_access', 0) == 1 || _.get(this.course, 'is_course_manager', 0) != 0);
        },
        notAvailableForLearner() {
          return _.get(this.user, 'level_access', 0) == 3 && (this.isDraft || this.isArchived);
        },
        showImagesSlider() {
          return this.courses.length > 3;
        },
        hasImages() {
          return !!_.get(this.course, 'carousel', []).length || (this.isPath && (!!this.course.pathways.find(p=>p.category.image) || !!this.course.pathways.find(p=>p.category && p.category.asMainCourse.find(c=>c.course.course_image))));
        },
        hasLike() {
          return _.get(this.course, 'has_like', false);
        },
        hasTabs(){
          return !!_.get(this.course, 'tabs', []).length
        },
        corporationStyles() {
          let styles = {};
          const courseViewColor = _.get(this, 'corporation.color_enroll_course_view', null);

          if (courseViewColor) {
            styles.backgroundColor = courseViewColor;
          }

          return styles;
        },
        isEnrollDisabled() {
            return this.course.id == 827;
        },
        showSoldOut(){
          return this.showSoldOutFunc(this.course);
        },
        showWaitList(){         
          return this.showWaitListFunc(this.course);
        },
        showWaitingWaitList(){
          return this.showWaitingFunc(this.course);
        },
        showWaitListFull() {
          return this.showFullFunc(this.course);
        },
        showViewCourse(){
        	return this.showInCourse(this.course)
        },
        /**/
        showRecertification(){
          if (!this.showRecertificationEnabled || !this.showInCourse(this.course) || !this.course.course_people_data || this.course.course_people_data.completed !== 1 || parseInt(this.course.certificate_time_validation) === 0){
            return false;
          }
          const certificateValidDate = moment(this.course.course_people_data.certificate_valid_date);
          const certificateAlertDate = moment(this.course.course_people_data.certificate_alert_date);
          const currentDate = moment();
          if (!certificateValidDate.isValid() || !certificateAlertDate.isValid() || certificateAlertDate.isBefore(currentDate) || certificateValidDate.isBefore(currentDate) ) {
            console.log('futureDate.isBefore');
            return true; 
          } else {
            console.log('futureDate.isAfter');
            return false; 
          }
        },/**/

        showEnroll(){

          var value = this.showEnrollFunc(this.course)

        	if(value && this.mustTriggerEnroll){
        		console.log("oppening enroll modal")
        	 	this.showEnrollModal()
        	}

          return value;
        },
        async isSeatCapacity(){
          let result = false;
           let responseCapacity = await API.checkoutProcess
          .getSeats(this.course.id)
          .then((apiResponse) => {
              let response = apiResponse.data; 
              this.seats = response.data;
             
              if(this.seats && this.seats.length >= 1){  
                    this.seats.forEach(element => {                                     
                        if(element.capacity - element.capacity_taken > 0 && !this.isRestricted(element)){                               
                           result = true;                          
                           return result;
                        }
                    });                  
                   
                   return result;
              }
             
              return result;
           });
           if(responseCapacity){              
              return result;
           }
        },
        showComingSoon(){
            return this.showComingSoonFunc(this.course);
        },
        showCourse(){
          const canShow = _.get(this.course, 'is_live', 0) == 1 || this.isOwnerOrCM;
          if(canShow) { this.loadCourseManager(); }
          return canShow;
        },
        canEnrollByAllowedDomains(){
          if (!is_catalogue_path || is_catalogue_path  && this.allowed_domains == ''){
            return true;
          }
          let myemail = _.get(this.user,'email', '').split("@");
          let mydomain = _.get(myemail,'1',null);
          let indomains = _.split(this.allowed_domains,",");
          if (_.indexOf(indomains,mydomain)>=0){
            return true;
          }
          if (myemail.indexOf(this.allowed_domains)>0 ) {
            return true;
          }
          console.log('Cant Enroll in this event because the email is not allowed in this catalog',myemail,this.allowed_domains);
          return false;
       },
       hasManageBtn: function() {
         return _.get(this.user, "ACL.Course.Create", 0) === 1 && (_.get(this.user, 'level_access', 0) == 1 || _.get(this.course, 'is_course_manager', 0) != 0);
       },
       isApplication() {
         return _.get(this.course, 'id_course_behavior', 0) === 1;
       },
       showStartDate() {
         return moment(this.course.course_start_date, 'YYYY-MM-DD').isValid();
       },
       showEndDate() {
         return moment(this.course.course_end_date, 'YYYY-MM-DD').isValid();
       },
       emailHref() {
          return `mailto:?Subject=${this.course.name}&body=${window.location.href}`;
        },
        categoriesValues() {
          return Object.values(this.$route.params);
        },
        custom_waitlist_count() {
          return _.get(this.course, 'custom_waitlist_count', 0);
        },
        custom_waitlist() {
          const id = this.custom_waitlist_count ? this.course.custom_waitlist_id.split(",").findIndex(i=>parseInt(i) === this.course.cwc_count) : null;
          return this.course && this.course.cwc_count && this.custom_waitlist_count ? {
            custom_waitlist: parseInt(this.course.custom_waitlist.split(",")[id]),
            custom_waitlist_1: this.course.custom_waitlist_1.split(",")[id],
            custom_waitlist_2: this.course.custom_waitlist_2.split(",")[id],
            custom_waitlist_3: this.course.custom_waitlist_3.split(",")[id],
            custom_waitlist_4: this.course.custom_waitlist_4.split(",")[id],
            custom_waitlist_5: this.course.custom_waitlist_5.split(",")[id],
            custom_waitlist_6: this.course.custom_waitlist_6.split(",")[id],
            custom_waitlist_7: this.course.custom_waitlist_7.split(",")[id],
            custom_waitlist_8: this.course.custom_waitlist_8.split(",")[id],
          } : {};
        },
        firstBttn() {
          return null;//this.custom_waitlist_count > 1 ? this.t('Select an option to Enroll') : this.course.custom_waitlist_1.split(",").find(x=>x);
        },
        secondBttn() {
          const id = this.custom_waitlist_count ? this.course.custom_waitlist_id.split(",").findIndex(i=>parseInt(i) === this.course.cwc_count) : null;
          return this.course.custom_waitlist_5.split(",")[id];
        },
        isPath() {
            return _.get(this.course, 'id_course_behavior', 0) === 2;
        },
        isPerformancePlan() {
            return _.get(this.course, 'id_course_behavior', 0) === 3;
        },
        currentYear() {
            return new Date().getFullYear();
        },
    },
    filters: {
        formatScheduleDate(dateToFormat) {
            const momentDate = moment(dateToFormat, "YYYY-MM-DD");
            return momentDate.format("DD");
        },
        formatScheduleTime(timeToFormat) {
            const momentDate = moment(timeToFormat, "HH:mm:ss");
            return momentDate.format("hh:mm a");
        },
        formatStartEndHour(timeToFormat) {
          const momentDate = moment(timeToFormat, "HH:mm:ss");
          if ( momentDate.format("hh:mm a") != "Invalid date") {
            return momentDate.format("hh:mm a");
          }
        },
        formatComingSoonDate(comingSoonDate) {
          return moment(comingSoonDate).utc().format("dddd, D MMM YYYY");
        },
        formatComingSoonHour(comingSoonDate, comingSoonHour) {
          return moment(comingSoonDate, "HH:mm:ss").format("LT");
        },
        formatAppDate(dateToFormat) {
          let longDateFormat = 'MMM D, YYYY';
          if(moment.locale() != 'en') { longDateFormat = 'D MMM YYYY'; }
          return moment(dateToFormat, "YYYY-MM-DD").format(longDateFormat);
        },
        toStartCase(str) {
          return _.startCase(str);
        }
    },
    methods: {
    $sanitize(content) {
      if (!content) return '';
      return DOMPurify.sanitize(content);
    },
      ...mapMutations(["setUser", 'setHasEnroll', 'setIdCourseSeat']),
      ...mapActions(['crudDataUser']),
      async doLaunch() {
        if(this.launching) return;
        this.launching = true;
        const courseId = parseInt(URI().segment(-1));
        this.getRequisites(courseId); //Right before loadCourse is called cuz this takes time and getRequisites gets the chance to load
        await this.loadCourse(courseId);
        //await this.loadCourses();
        await this.getUser();
        this.$nextTick(() => this.launching = false);
      },
      async reCertification(){
        console.log('reCertification');
        let loader = this.$loading.show();
        const responseData = await API.checkoutProcess.recertificate({
          body: {
            id_course : this.course.id,
            id_people : this.user.id
          }
        });
        loader.hide();
        if (this.course && this.course.modules && this.course.modules[0]){
          console.log(this.course.modules[0].id_course_module);
          window.location.href = "/index.php?r=courseModule&idModule=" + this.course.modules[0].id_course_module;
        } else {
          window.location.href = `${window.location.protocol}//${window.location.hostname}/apprendo/dashboard#/my_courses`;
        }
      },
      isRestricted(seatItem) {
        return !this.isAOorCMIC && seatItem.authorized_domains && seatItem.authorized_domains.split(',').filter(authorized_domain=>/\w+\.\w+(\.\w+)*/.test(authorized_domain.trim())).find(authorized_domain=>authorized_domain.trim().toLowerCase() === this.user.email.split('@')[1].trim().toLowerCase()) === undefined;
      },
      btnShowWaitListModal(seat){
        if(this.isWaitlistSeat(seat)) {
          this.seatSelected = seat;         
          //this.openWaitListModal = true;
          //this.pendingWaitList = false;
          this.waitListCourseID = this.course.id;
          this.showDialog = false;
          this.openDialog = true;
        } else {
          this.showDialog = false;
          this.setIdCourseSeat(seat.id_course_seat);
          this.showEnrollModal();
        }
      },
        goBack() {
          this.showDialog = false;
          // window.history.back();
        },
      validationFullName(){
         let longFullName = this.userFirstName.split(' ');
         longFullName = longFullName.filter(x => x.trim() != "");

         if(this.userFirstName && this.userFirstName.trim().length > 0 && longFullName.length >= 2)
           return true;
         else
           return false;
      },
      async setFirstName(){
        let userFullName = this.userFirstName;
        this.userFirstName = '';

        if(userFullName && userFullName.length >= 2){

           var name_lastname = userFullName.split(" ");
		        var final_name = "";
		        var final_lastname = "";

		        switch(name_lastname.length){
		        case 1 :
		        	final_name = name_lastname[0]
		        	break;
		        case 2:
		        	final_name = name_lastname[0]
		        	final_lastname = name_lastname[1]
		        	break;
		        case 3 :
		        	final_name = name_lastname[0]
		        	final_lastname = name_lastname[1] +" "+name_lastname[2]
		        	break;
		        default :
		        	final_name = name_lastname[0] +" "+ name_lastname[1]
		        	final_lastname = name_lastname[2] +" "+name_lastname[3]
		        	break;
		        }

             if(!this.userData.people_work_phone){
              const responseData = await API.domain.crudDataUser({
                body: {
                  id_user : this.user.id
                }
              });

              this.userData = responseData.data.User;

              this.userData.people_work_phone = responseData.data.People.people_work_phone;

            }

            this.$set(this.user, "first_name", final_name);
            this.$set(this.user,"last_name", final_lastname);
            this.setUser(this.user);
            if(this.userData.people_work_phone){
              this.$set(this.user,"people_work_phone", this.userData.people_work_phone);
            }
            this.setUser(this.user);   

            this.userData.name = final_name;
            this.userData.lastname = final_lastname;
            this.userData.email = this.user.email;          

           const response =  await API.domain.crudDataUser({
              body: {
                id_user : this.user.id,
                option : "save",
                data : JSON.stringify({user:this.userData,fields:{},fieldsCourse:[]})
              }
            });   
            
            this.showModal = false;
            
        }

      },
        formatScheduleMonth(dateToFormat) {
          let momentDate = moment(dateToFormat, "YYYY-MM-DD");
          momentDate = momentDate.format("MMM");

          momentDate = momentDate.replace("Jan", this.t("Jan"))
          momentDate = momentDate.replace("Apr", this.t("Apr"))
          momentDate = momentDate.replace("Aug", this.t("Aug"))
          momentDate = momentDate.replace("Dec", this.t("Dec"))

          return momentDate

        },
        formatStartEndDate(timeToFormat) {
          let momentDate = moment(timeToFormat, "YYYY-MM-DD")
          momentDate = momentDate.format("dddd, D MMM YYYY");

          momentDate = momentDate.replace("Monday", this.t("Monday"))
          momentDate = momentDate.replace("Tuesday", this.t("Tuesday"))
          momentDate = momentDate.replace("Wednesday", this.t("Wednesday"))
          momentDate = momentDate.replace("Thursday", this.t("Thursday"))
          momentDate = momentDate.replace("Friday", this.t("Friday"))
          momentDate = momentDate.replace("Saturday", this.t("Saturday"))
          momentDate = momentDate.replace("Sunday", this.t("Sunday"))

          momentDate = momentDate.replace("Jan", this.t("Jan"))
          momentDate = momentDate.replace("Apr", this.t("Apr"))
          momentDate = momentDate.replace("Aug", this.t("Aug"))
          momentDate = momentDate.replace("Dec", this.t("Dec"))

          return momentDate

        },
        translateCourseType(courseType){
          courseType = courseType.replace("onsite", this.t("onsite"))
          courseType = courseType.replace("online", this.t("online"))
          courseType = courseType.replace("blended", this.t("blended"))

          return courseType
        },
        translateHome(text){
          text = text.replace("Home", this.t("Home"))
          return text
        },
        removeCurrency(price){
          if(price){
            // let example = "$11.66 CAD"
            // console.log('Current price', price);
            if(typeof price === "string"){
                let array = price.split(" ");
                return array[0];
            }else{
                return `$${price.toString()}`; //"$11.66"
            }
          }else{
            return ""
          }
        },
        getRangeOfPrices(price, highest_price){
            price = price === 'Free' || price === 0 ? price = this.t('FREE') : this.removeCurrency(price);
            highest_price = this.removeCurrency(highest_price);

            // console.log('Prices', price, highest_price);
            if(price === highest_price){
                return price
            }else{
                return `${price} - ${highest_price}`
            }
        },
        freeSeats(price, highest_price){
            price = price === 'Free' || price === 0 ? price = 0 : price;
            highest_price = highest_price === 'Free' || highest_price === 0 || highest_price === null ? highest_price = 0 : highest_price;

            if(price === highest_price){
                return true
            }else{
                return false
            }
        },
        showEnrollModal() {
            this.enroll(this.course.id);
        },
        isEnrollMultiple() {
            return this.course.id_enroll_mode == 3;
            //return this.showViewCourse();
        },
        refresh() {

        	location.reload();
        	return false;
        	console.log("refresing");
          this.loadCourse(this.course.id);

          if (this.showImagesSlider) {
            this.loadCourses();
          }
        },
        async loadCourse(courseId) {
          try {
            let loader = this.$loading.show();
            const apiResponse = await (CATALOGUE_PATH ? API.main.getCourseByCat(courseId, CATALOGUE_PATH) : API.main.getCourse(courseId));
            this.course = apiResponse.data;
            if(this.isLoggedIn && this.isApplication) {
              this.validatingApplied = true;
              API.domain.applications({body: { id_application: this.course.id_course, }}).then(apiResponse=>{
                this.$set(this.course, 'id_applied', _.get(apiResponse.data, 'id_applied', false));
              }).finally(()=>this.validatingApplied = false);
            }
            // Load existing performance plans for the user
            if(this.isLoggedIn && this.isPerformancePlan) {
              this.loadMyPerformancePlans();
            }
            
            this.course.hosts = []
            this.course.categories = []
            this.course.competences = []

            for(var i = 0;i<this.course.allcategories.length;i++){
            	var type = this.course.allcategories[i].id_category_type
            	if(type == 2){
            		this.course.hosts.push(this.course.allcategories[i])
            	}
            	if(type == 1){
            		this.course.categories.push(this.course.allcategories[i])
            	}
            	if(type == 3){
            		this.course.competences.push(this.course.allcategories[i])
            	}
            }

            if (this.corporation && this.corporation.id) {
            getRootCssCorporation(this.corporation.id);
            }
            if(this.course.time_option === 3) {
              API.course.getSchedule(courseId).then((scheduleResponse) => {
                this.schedule = _.get(scheduleResponse.data, 'data[0].items', []);
                this.schedule.forEach(day=>{
                  if(day.location_option)  {
                      if(!day.id_location) {
                      const loc = this.course.locations.find(loc=>loc.ref === day.ref);
                      if(loc) {
                        day.location = loc;
                      }
                    }
                  }
                });
              });
            }
            
            if(this.course.time_option === 2 && this.course.location_option === 1) {
              if(!this.course.id_location) {
                this.course.location = this.course.locations.find(loc=>!loc.ref);
              }
            }
            this.$nextTick(()=>this.courseLoaded = true);
            loader.hide();
          } catch(e) {
            location.reload();
          }
        },
        async loadCourseManager(){
          if(!this.isLoggedIn) return; //This endpoint requires to be logged-in
            //const loader = this.$loading.show();
            const apiResponse = await API.course.coursePeople({
                id_course:this.course.id_course,
                getManagers : 1,
                page : 1,
                filter_name  : " ",
                id_course_external: 0,
            });
            if (apiResponse.data.data.length){
                this.courseNewManagers = apiResponse.data.data;
            }
            console.log(this.courseNewManagers);
            //loader.hide();
        },
        async loadCourses() {
          let criteria = { id_to_ignore: this.course.id_course };
          if(this.isApplication) {
            criteria['applications'] = true;
          }
            API.main.getCourses(criteria).then((apiResponse) => {
              this.courses = apiResponse.data.courses;
            });
        },

        handleScroll() {
          if(this.$refs['mobileEnrollBtn'])
            this.showMobileHeader = window.scrollY > this.$refs.mobileEnrollBtn.getBoundingClientRect().top;
        },
        toggleGoToSection() {
            this.expandGoToSection = !this.expandGoToSection;
        },
        goToSection(sectionRef) {

        	if(sectionRef=="section_tabs"){
        		this.tabIndex = 0;
        	}

            const sectionEl = _.isArray(this.$refs[sectionRef]) ? this.$refs[sectionRef][0] : this.$refs[sectionRef];
            this.expandGoToSection = false;
            sectionEl.scrollIntoView(true);
            window.scrollBy(0, -95);
        },
         goToSectionAbout() {
            const sectionEl = _.isArray(this.$refs[sectionRef]) ? this.$refs[sectionRef][0] : this.$refs[sectionRef];
            this.expandGoToSection = false;
            sectionEl.scrollIntoView(true);
            window.scrollBy(0, -95);
        },
        closeAddedFavoritesModal() {
          this.showAddedFavoritesModal = false;
        },
        goToFavorites() {
          const loader = this.$loading.show();
          this.showAddedFavoritesModal = false;
          window.location.href = `${window.location.protocol}//${window.location.hostname}/apprendo/dashboard/#/my_preferences/favorites`;
        },
        seeMoreEvents() {
          const loader = this.$loading.show();
          this.showAddedFavoritesModal = false;
          window.location.href = `${window.location.protocol}//${window.location.hostname}${this.course.breadcrumb.find(bc=>bc.text == 'Home').url}`;
        },
        getRandomRgb() {
          return `rgb(${[0,0,0].map(()=>Math.floor(Math.random() * 256)).join(',')})`;
        },
        shareFB() {
          this.runShare(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}&amp;src=sdkpreparse`);
        },
        shareTR() {
          this.runShare(`https://x.com/intent/post?url=${encodeURIComponent(window.location.href)}`);
        },
        runShare(urlRef) {
          var myWindow = window.open(urlRef, "", "width=670,height=400");
        },
        openStartApplication() {
          if(this.isLoggedIn) {
            this.applyAppModal = true;
          } else {
            this.pendingApplyAppModal = true;
            this.openLoginDialog();
          }
        },
        startApplication() {
          if(this.isLoggedIn) {
            if(this.course.id_applied && !this.tryNewApplication) {
              window.location.href = `${window.location.protocol}//${window.location.hostname}/apprendo/dashboard#/myApplications/applications`;
            } else {
              this.doStartApplication();
            }
          } else {
            this.pendingStartApplication = true;
            this.openLoginDialog();
          }
        },
        doStartApplication() {
          this.applyingApp = true;
          API.domain.applications({body: { id_course: this.course.id_course, try_new: this.tryNewApplication, }})
          .then(response=>{
            this.applyAppModal = false;
            const loader = this.$loading.show();
            window.location.href = `${window.location.protocol}//${window.location.hostname}/apprendo/dashboard#/myApplication/${response.data.form_id_application}`;
          }).finally(()=> {
            this.applyingApp = false;
            this.tryNewApplication = false;
          });
        },
        // Performance Plan methods
        async loadMyPerformancePlans() {
          if (!this.isLoggedIn || !this.isPerformancePlan) return;
          this.loadingMyPlans = true;
          try {
            const response = await API.performancePlans.myPlans({ id_course: this.course.id_course });
            if (response.data && response.data.success) {
              this.myPerformancePlans = response.data.data || [];
            }
          } catch (error) {
            console.error('Error loading performance plans:', error);
          } finally {
            this.loadingMyPlans = false;
          }
        },
        openStartPlanModal() {
          if (this.isLoggedIn) {
            this.performancePlanModal = true;
          } else {
            this.openLoginDialog();
          }
        },
        async startNewPlan() {
          if (!this.isLoggedIn) {
            this.openLoginDialog();
            return;
          }
          this.startingPlan = true;
          try {
            console.log('startNewPlan - calling API with:', {
              id_course: this.course.id_course,
              plan_year: this.currentYear
            });
            const response = await API.performancePlans.startPlan({
              id_course: this.course.id_course,
              plan_year: this.currentYear
            });
            console.log('startNewPlan - API response:', response);
            console.log('startNewPlan - response.data:', response.data);
            console.log('startNewPlan - response.data.data:', response.data?.data);
            console.log('startNewPlan - id_plan:', response.data?.data?.id_plan);
            if (response.data && response.data.success) {
              this.performancePlanModal = false;
              const loader = this.$loading.show();
              window.location.href = `${window.location.protocol}//${window.location.hostname}/apprendo/dashboard#/performancePlan/${response.data.data.id_plan}`;
            } else {
              this.$message.error(response.data.error || this.t('Failed to start plan'));
            }
          } catch (error) {
            console.error('Error starting plan:', error);
            this.$message.error(this.t('Failed to start plan'));
          } finally {
            this.startingPlan = false;
          }
        },
        continuePlan(plan) {
          window.location.href = `${window.location.protocol}//${window.location.hostname}/apprendo/dashboard#/performancePlan/${plan.id_plan}`;
        },
        async getUser(){
          if(!this.isLoggedIn) return;
          let userId =  _.get(this.user, 'id', 0);
          console.log("esto es el id user: ", userId);
          // if(userId){
              console.log("esto tiene log user: ", _.get(this, 'user.id', 0));
              await API.domain.crudDataUser({
                body: {
                  id_user : 0
                }
              }).then((response) => {
                  if(response && response.data && response.data.User){
                  console.log("esto tiene user first name: ", response.data.User);
                  console.log("esto tiene isLoggedIn: ", this.isLoggedIn);
                  this.userData = response.data.User;

                  if(this.isLoggedIn && this.userData && this.userData.name && this.userData.lastname && (this.userData.name.toUpperCase() + this.userData.lastname.toUpperCase()) == 'YOURNAME'){
                      if(this.showDialog == true){
                        this.showChangeModal = true;
                        this.showDialog = false;
                      }                       
                      this.showModal = true;
                  }       
                  
                  this.userData.people_work_phone = response.data.People.people_work_phone;
                  console.log("User Data : ", this.userData);
                  this.$set(this.user, "first_name", this.userData.name);
                  this.$set(this.user,"last_name", this.userData.lastname);
                  this.$set(this.user,"level_access", this.userData.level_access);
                  this.$set(this.user,"people_work_phone", response.data.People.people_work_phone);
                  this.setUser(this.user);
                  }           

                  return this.user;  
              });                              
            // }     
        },
        getPath(index) {
          let path = PAGES.LIST + "#";
          for (let i = 0; i <= index; i++) {
            path += '/' + this.categoriesValues[i];
          }

          return path;
        },
        changeWaitlist(isAdded,id_course_seat) {
          this.course.user_in_wait_list = isAdded ? 1 : 0;
          if(isAdded) { this.course.current_users += 1; this.course.cwc_count = id_course_seat; } else { this.course.current_users -= 1; this.course.cwc_count = null; }
        },
        isWaitlistSeat(seatItem) {
          const full_seats = seatItem.capacity_taken >= seatItem.capacity, current_users = _.get(this.waitlistCount.find(wc=>wc.id_course_seat===seatItem.id_course_seat), 'current_users', 0);
          return this.showWaitListFunc(Object.assign({}, this.course, { full_seats: full_seats, current_users: !!current_users, }));
        },
        closesCollapse(path) {
            $(`#courses-${path.id_category}`).collapse('hide');
        },
        titleTab(itemTitle){
          itemTitle = itemTitle.replace("About", this.t("About"));
          itemTitle = itemTitle.replace("What is needed for this course", "What is needed for this event");
          itemTitle = itemTitle.replace("What is needed for this event", this.t("What is needed for this event"));
          itemTitle = itemTitle.replace("Additional Information", this.t("Additional Information"));
          itemTitle = itemTitle.replace("Who is this for", this.t("Who is this for"));

          return itemTitle
          },
        openFollowPath() {
          if(this.isLoggedIn) {
            this.showfollowModal = true;
          } else {
            this.pendingShowfollowModal = true;
            this.openLoginDialog();
          }
        },
        async followPath() {
          const loader = this.$loading.show();
          const response = await API.course.followPath({
            id_course: this.course.id_course,
          });
          this.course.course_people_data = response.data.followPathway;
          this.showfollowModal = false;
          loader.hide();
        },
        unfollowPath() {
          this.showUnfollowModal = true;
        },
        async doUnfollowPath() {
          const loader = this.$loading.show();
          await API.course.unFollowPath({
            id_course_people: this.course.course_people_data.id_course_people,
          });
          this.course.course_people_data.pathway_enroll_type = 0;
          this.showUnfollowModal = false;
          loader.hide();
        },
        getRandomColor() {
            // if randomColor cndjs is not available
            let letters = '0123456789ABCDEF';
            let color = '#';
            for (let i = 0; i < 6; i++) {
                color += letters[Math.floor(Math.random() * 16777216)];
            }
            return color;
        },
        linearGradient() {
          let a = typeof randomColor == 'function' ? randomColor() : this.getRandomColor();
          let b = typeof randomColor == 'function' ? randomColor() : this.getRandomColor();
          return `linear-gradient(to right, ${a}, ${b})`;
        },
        openCourse(id_course) {
          window.open(`/marketplace/courses/${id_course}`, '_blank');
        },
        openApp(form_id_application) {
          window.open(`/apprendo/dashboard#/myApplication/${form_id_application}`, '_blank');
        },
        openChoose(course) {
          console.log('course', course);
          if(course.id_course_behavior) {
            this.openApp(course.courseApplication.courseApplicationUser.form_id_application);
          } else {
            this.openCourse(course.id_course);
          }
        },
        openInstructor(instructor) {
          window.location.href = `/marketplace/index#/instructors/${[instructor.id_user,instructor.name,instructor.lastname].filter(word=>word).join('-')}`;
        },
        getLocationDesc(loc) {
          if(!loc) return
            let address = [loc.name, loc.address, [loc.city, loc.state, loc.zip_code, loc.country].filter(v=>v).join(', '), loc.notes, ].filter(v=>v).join('\n');
            let building = [loc.building_name, [loc.building_room, loc.building_foor].filter(v=>v).join(', '), loc.building_notes, ].filter(v=>v).join('\n');
            if(building) building += '\n\n';
            return building + address;
        },
        trackEnrollClick() {
          // Only proceed if not disabled
          if (!this.isEnrollDisabled) {
            try {
              // Initialize dataLayer if it doesn't exist
              window.dataLayer = window.dataLayer || [];
              
              // Create enrollment click event data
              const enrollEventData = {
                'event': 'enrollment_button_click',
                'course': {
                  'item_name': this.course.course_name,
                  'item_id': this.course.id_course,
                  'price': this.course.course_price,
                  'currency': this.course.currency || 'USD'
                }
              };
              
              // Push event to dataLayer
              window.dataLayer.push(enrollEventData);
              
              // For debugging
              console.log('Enrollment click event pushed to dataLayer:', enrollEventData);
            } catch (error) {
              console.error('Error pushing enrollment click event to dataLayer:', error);
            }
            
            // Call the original function
            this.showEnrollModal();
          }
        }
    },
    async mounted() {
        // await this.getUser();
        window.addEventListener('scroll', this.handleScroll);
        //getRootCssCorporation(this.corporation.id);
    },
    async created() {
    	if(this.hasEnroll){
    		//this.mustTriggerEnroll = true;
        this.setHasEnroll(false);
    	}

    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    },
}

</script>
<style lang="postcss">
.disabledFirstName.disabled, .disabledFirstName:disabled {
    color: #7e838a; 
    background-color: #d5d8dc; 
    border-color: transparent; 
    border-radius: 4px;    
     font-size: 16px;
}
.disabledFirstName{
   color: #7e838a; 
    background-color: #d5d8dc; 
    border-color: transparent; 
    border-radius: 4px;
   cursor:pointer;    
   width: 480px; 
   height: 48px;   
   justify-content: center; 
   align-items: center;
    font-size: 16px;
 }
 .enableFirstName:hover{
   background-color: #194a7d ;
   border-color: transparent;   
   border-radius: 4px;  
   box-shadow: 0px 4px 8px rgb(37 106 179 / 50%);
   cursor:pointer; 
   color: white;  
   width: 480px; 
   height: 48px;    
   justify-content: center; 
   align-items: center;
   font-size: 16px;
 }
 .enableFirstName{
   background-color: #256ab3; 
   border-color: transparent;   
   border-radius: 4px;  
   box-shadow: 0px 4px 8px rgb(37 106 179 / 50%);
   cursor:pointer; 
   font-size: 16px;
   color: white;  
   width: 480px; 
   height: 48px;    
   justify-content: center; 
   align-items: center;
 }
.dropdown-toggle:after {
  display: none;
}
.modal-dialog .md-dialog-container .modal-content {
  overflow-y: auto;
}

.dropdown.user-options label {
  -webkit-appearance: initial !important;
}
.modal-dialog.select-seats h3 {
  font-family: "Source Sans Pro";
  font-size: 40px;
  line-height: 0.15;
  text-align: left;
  color: #4a4a4a;
  margin-top: 0;
  margin-bottom: 10px;
}
.md-dialog {
  /*width: 550px;*/
}
.md-dialog-container {
  /*padding: 30px;*/
}

.user-modal .md-dialog-container {
  background-color: #f6f6f6;
}

.vnis__button {
  border: 1px solid #256ab3 !important;
  background-color: #fff !important;
  height: 25px !important;
  width: 25px !important;
  color: #256ab3 !important;
  padding-top: 1px;
  border-radius: 5px !important;
}

.vnis__input {
  height: 25px !important;
  border: none !important;
  width: calc(100% - 60px) !important;
}

.single-enroll-page {
  min-height: 500px;
}

.btn-outline-primary {
  border-color: #256ab3;
  color: #383838;
}
.btn.btn-outline-primary:hover {
  border-color: #256ab3;
  background-color: #d3e1ef;
  color: #383838;
}

/* Smartphones (portrait and landscape) ----------- */
@media only screen and (min-width: 320px) and (max-width: 480px) {
  .md-dialog-fullscreen.select-seats .md-dialog-container {
    /*padding: 20px;*/
  }

  .container {
    padding-top: 0;
  }

  .md-dialog-actions {
    padding: 0;
    width: 100%;
  }

  .md-dialog-actions button {
    width: 100%;
    height: 60px;
  }

  .totals-section {
    margin-top: 20px;
  }

  .totals-section label {
    font-family: "Source Sans Pro";
    font-size: 18px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.22;
    letter-spacing: normal;
    color: #383838;
  }

  .vnis__button {
    width: 35px !important;
    height: 35px !important;
  }

  .vnis__input {
    width: calc(100% - 100px) !important;
    margin-top: 5px;
    font-family: "Source Sans Pro";
    font-size: 18px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.22;
    letter-spacing: normal;
    color: #383838;
  }
}

/* iPads (portrait and landscape) ----------- */
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .md-dialog-fullscreen.select-seats .md-dialog-container {
    /*padding: 20px;*/
  }
}

/* Desktop */
@media only screen and (min-width: 1224px) {
  .md-dialog {
    border-radius: 5px;
    min-width: 745px;
    /*width: 550px;*/
  }
}

@media (min-width: 576px) {
  .single-enroll-page .center {
    margin-left: 252px;
  }
}

.seat-section {
  border-left: 1px solid #ababab;
  border-right: 1px solid #ababab;
  border-bottom: 1px solid #ababab;
  background-color: #fff;

  font-family: "Source Sans Pro";
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.22;
  letter-spacing: normal;
  color: #383838;
}

.seat-section.top {
  border-top: 1px solid #ababab;
}

h2.select-seats {
  font-family: "Source Sans Pro";
  font-size: 30px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.27;
  letter-spacing: normal;
  color: #383838;
}

label.select-seats {
  font-family: "Source Sans Pro";
  font-size: 20px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.3;
  letter-spacing: normal;
  color: #383838;
}

.has-error .form-control {
  border-color: #d95a4b !important;
}

.md-error {
  color: #d95a4b !important;
}
</style>

<style lang="postcss">
.disabledFirstName.disabled, .disabledFirstName:disabled {
    color: #7e838a;
    background-color: #d5d8dc;
    border-color: transparent;
    border-radius: 4px;
     font-size: 16px;
}
.disabledFirstName{
   color: #7e838a;
    background-color: #d5d8dc;
    border-color: transparent;
    border-radius: 4px;
   cursor:pointer;
   width: 480px;
   height: 48px;
   display:flex;
   justify-content: center;
   align-items: center;
    font-size: 16px;
 }
 .enableFirstName:hover{
   background-color: #194a7d ;
   border-color: transparent;
   border-radius: 4px;
   box-shadow: 0px 4px 8px rgb(37 106 179 / 50%);
   cursor:pointer;
   color: white;
   width: 480px;
   height: 48px;
   display:flex;
   justify-content: center;
   align-items: center;
    font-size: 16px;
 }
 .enableFirstName{
   background-color: #256ab3;
   border-color: transparent;
   border-radius: 4px;
   box-shadow: 0px 4px 8px rgb(37 106 179 / 50%);
   cursor:pointer;
   font-size: 16px;
   color: white;
   width: 480px;
   height: 48px;
   display:flex;
   justify-content: center;
   align-items: center;
 }
  @media (min-width: 1200px) {
    .container {
      width: 1170px;
      max-width: 1170px;
    }
  }

  .md-dialog {
    border-radius: 5px;
  }

  .modal-dialog.request-pay .modal-content {
    min-height: initial !important;
  }

  .nav-item a.nav-link.active {
      background-color: #f1f7fb !important;
  }
</style>

<style scoped>
 /* init waitlist modal */
  .btn-default.blue,
    .btn-default.blue:hover {
        width: 250px;
        height: 35px;
        color: white !important;
        text-decoration: none;
        padding-top: 8px;
        font-size: 18px;
        line-height: 22px;
        font-family: "Source Sans Pro";
    }

    .btn-outline-primary {
    color: #383838;
    background-color: #ffffff;
    background-image: none;
    border-color: #256AB3;
    }
    .btn-outline-primary:hover {
        background-color: #D3E1EF;   
    }

    h3 {
        color: #383838;
        font-family: "Source Sans Pro";
        font-size: 40px;
        line-height: 46px;
        text-align: center;
    }

    p {
        color: #383838;
        font-family: "Source Sans Pro";
        font-size: 18px;
        line-height: 22px;
    }

    /* fin waitlist modal */

  label .fa {
    color: #256ab3;
  }

  label.active .fa {
    color: white;
  }

  .date-area .month {
    background-color: #D95A4B;
    border-top-left-radius: .25rem !important;
    text-transform: uppercase;

    height: 18px;
    width: 42px;
    color: #FFFFFF;
    font-family: "Source Sans Pro";
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    text-align: center;
  }


  .date-area .day {
    background-color: white;
    border-bottom-right-radius: .25rem !important;
    height: 32px;
    width: 42px;
    text-align: center;
  }

  .date-area .day span {
    color: #383838;
    font-family: "Source Sans Pro";
    font-size: 25px;
    line-height: 32px;
  }
  
.app-outline.big {
      min-height: 52.5px;
}

a.app-a {
    text-decoration: none;
    color: #256ab3;
}
a.link-app {
    text-decoration: none;
    color: #256ab3;
    font-size:16px;
}
a.link-app {
 color: #19497C;
}
a.app-a:hover,
.app-outline a:hover {
	text-decoration:none;
}
.learner-in-draft {
  text-align: center;
}
.learner-in-draft /deep/ ol.breadcrumb {
  margin-top: 38px;
  margin-bottom: 50px;
}
.learner-in-draft /deep/ ol .breadcrumb-item a {
  color: rgb(37,106,179);
}
.learner-in-draft /deep/ ol .breadcrumb-item+.breadcrumb-item::before {
  color: rgb(37,106,179);
   content: "»";
}
.learner-in-draft /deep/ h1,
.learner-in-draft /deep/ p {
  color: rgb(56,56,56);
  display: block;
  font-family: "Source Sans Pro";
}
.learner-in-draft /deep/ h1 {
  font-size: 40px;
  margin-top: 24px;
  margin-bottom: 8px;
}
.learner-in-draft /deep/ p {
  margin-bottom: 0px;
  font-size: 16px;
  text-align: center;
}
.learner-in-draft /deep/ p a {
  color: rgb(37,106,179);
}
.learner-in-draft /deep/ .btn.btn-orange {
  background-color: rgb(231,106,32);
  color: rgb(255, 255, 255);
  font-family: "Source Sans Pro";
  font-size: 18px;
  line-height: 22px;
  margin-top: 40px;
  margin-bottom: 88px;
  padding: 9px 17px !important;
  width: initial !important;
}
.coming-soon-date-time {
  background-color: rgb(252,225,38);
  color: rgb(56,56,56);
  font-family: "Source Sans Pro";
  font-size: 16px;
  line-height: 20px;
  margin-top: 1px;
  text-align: center;
  padding: 6px;
}
.course-header:not(.is-path),
.app-header {
  align-items: center;
  display: grid;
  grid-template-columns: 32px 1fr;
  gap: 16px;
}
.course-header /deep/ svg:focus,
.app-header /deep/ svg:focus {
  outline: none;
}
.main-section /deep/ .breadcrumb,
.app-section /deep/ .breadcrumb {
    border: 1px solid rgb(227,229,232);
    margin-bottom: 42px;
    margin-top: 38px;
    padding: 10px 20px;
}
.main-section /deep/ .breadcrumb .breadcrumb-item,
.app-section /deep/ .breadcrumb .breadcrumb-item {
    color: rgb(56,56,56);
    font-size: 16px;
    line-height: 22px;
    padding-left: 0;
}
.main-section /deep/ .breadcrumb .breadcrumb-item+.breadcrumb-item,
.app-section /deep/ .breadcrumb .breadcrumb-item+.breadcrumb-item {
    padding-left: 17px;
}
.main-section /deep/ .breadcrumb .breadcrumb-item > a,
.app-section /deep/ .breadcrumb .breadcrumb-item > a {
   
    font-size: 16px;
    line-height: 22px;
}
.main-section /deep/ .breadcrumb .breadcrumb-item+.breadcrumb-item::before,
.app-section /deep/ .breadcrumb .breadcrumb-item+.breadcrumb-item::before {
    color: #383838;
    content: "»";
    padding-right: 13px;
}
.course-breadcrumb {
    align-items: center;
    display: grid;
}
.course-breadcrumb.has-manage-btn {
    grid-template-columns: 1fr auto;
    gap: 40px;
}
.course-breadcrumb /deep/ .btn-manage-event {
    border-radius: 4px;
    display: inline-block;
    line-height: 22px;
    min-width: 168px;
    padding: 8px 24px;
    text-align: center;
}
.course-breadcrumb /deep/ .btn-manage-event:hover,
.course-breadcrumb /deep/ .btn-manage-event:active,
.course-breadcrumb /deep/ .btn-manage-event:focus {
    
    text-decoration: none;
}
.course-breadcrumb.has-manage-btn {
    grid-template-columns: 1fr auto;
    gap: 40px;
}
.course-header /deep/ .title-description,
.title-description {
  color: rgb(56,56,56);
  font-family: "Source Sans Pro";
  font-size: 40px;
  line-height: 46px;
}
.added-to-favorites-modal {
  max-height: initial;
  width: 687px;
}
.added-to-favorites-modal /deep/ .btn-outline-primary {
  border-color: rgb(37,106,179);
  color: rgb(56,56,56);
}
.added-to-favorites-modal /deep/ .btn-outline-primary:hover,
.added-to-favorites-modal /deep/ .btn-outline-primary:active,
.added-to-favorites-modal /deep/ .btn-outline-primary:focus {
  /**background-color: rgb(37,106,179);**/
  border-color: rgb(25,74,125);
  /**color: rgb(255,255,255);**/
}
.added-to-favorites-modal /deep/ .btn-primary {
  background-color: rgb(37,106,179);
  border-color: rgb(37,106,179);
}
.added-to-favorites-modal /deep/ .btn-primary:hover,
.added-to-favorites-modal /deep/ .btn-primary:active,
.added-to-favorites-modal /deep/ .btn-primary:focus {
  background-color: rgb(25,74,125);
  border-color: rgb(25,74,125);
}
.added-to-favorites-modal /deep/ .md-dialog-container {
  max-height: initial;
}
.img-fluid-container {
  position: relative;
}
.img-fluid-container /deep/ img,
.img-fluid-container /deep/ canvas {
  display: block;
  height: auto;
  max-height: 184px;
  max-width: 600px;
  object-fit: cover;
  width: 100%;
}
.app-section {}
.app-title {
  color: rgb(56,56,56);
  font-family: "Source Sans Pro";
  font-size: 40px;
  font-weight: bolder;
  line-height: 46px;
  margin-bottom: 0;
}
.app-subtitle {
  color: rgb(159,165,172);
  font-family: "Source Sans Pro";
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 1px;
  line-height: 16px;
  margin-bottom: 0;
  text-align: left;
}
.app-subtitle /deep/ .app-type,
.app-subtitle /deep/ .app-available {
  text-transform: uppercase;
}
.app-mb {
  margin-bottom: 32px;
}
.app-image img,
.app-image canvas {
  aspect-ratio: 1100/330;
  display: block;
  object-fit: cover;
  width: 100%;
}
.app-info-title {
  align-items: center;
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 9px;
  margin-top: 40px;
}
.app-info-title /deep/ p {
  color: rgb(56,56,56);
  font-family: "Source Sans Pro";
  font-size: 18px;
  font-weight: bolder;
  line-height: 22px;
  margin-bottom: 0;
  text-align: left;
}
.app-description {
  color: rgb(56,56,56);
  font-family: "Source Sans Pro";
  font-size: 16px;
  line-height: 22px;
  padding-top: 16px;
  padding-bottom: 38px;
}
.app-description /deep/ p {
  margin-bottom: 0;
}
.app-btn {
  background-color: rgb(231,106,32);
  border: none;
  border-radius: 4px;
  color: rgb(255,255,255);
  display: block;
  font-family: "Source Sans Pro";
  font-size: 22px;
  line-height: 26px;
  padding: 8px 12px;
  text-align: center;
  width: 100%;
}
.app-btn:hover,
.app-btn:active,
.app-btn:focus {
  background-color: rgb(184,84,25);
}
.app-btn.disabled {
  background-color: rgb(227,229,232);
  border: none;
  color: rgb(159,165,172);
  cursor: not-allowed;
  filter: alpha(opacity=100);
  opacity: 1;
}
.app-share {
  color: rgb(56,56,56);
  font-family: "Source Sans Pro";
  font-size: 18px;
  font-weight: bold;
  line-height: 22px;
  padding: 80px 0;
  text-align: center;
}
.app-share /deep/ .social-media {
  align-items: center;
  display: grid;
  grid-template-columns: repeat(auto-fit, 30px);
  gap: 6px;
  justify-content: center;
  margin-top: 6px;
}

.app-share /deep/ .social-media a {
  background-color: rgb(37,106,179);
  border-radius: 50%;
  display: inline-block;
  height: 30px;
  position: relative;
  text-align: center;
  vertical-align: middle;
  width: 30px;
}
.app-share /deep/ .social-media a svg {
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
}
.app-carousel {
  background-color: rgb(233,233,233);
  padding: 40px;
}
.app-carousel /deep/ .app-carousel-hdr {
  color: rgb(56,56,56);
  font-family: "Source Sans Pro";
  font-size: 22px;
  font-weight: bolder;
  line-height: 26px;
  margin-bottom: 0;
  padding-left: 15px;
}
.app-carousel /deep/ .cards-list,
.courses-slider-container /deep/ .cards-list {
  width: 100%;
}
.modal-apply-application {
  background-color: rgb(246,246,246);
}
.modal-apply-application /deep/ .app-info h1 {
  color: rgb(56,56,56);
  font-family: "Source Sans Pro";
  font-size: 40px;
  line-height: 46px;
  text-align: center;
}
.modal-apply-application /deep/ .app-actions {
  border-top: 1px solid rgb(171,171,171);
  display: grid;
  grid-template-columns: repeat(2, auto);
  justify-content: space-between;
  padding-top: 22px;
  margin-top: 22px;
}
.modal-apply-application /deep/ .app-actions .btn {
  border: none;
  border-radius: 4px;
  font-family: "Source Sans Pro";
  font-size: 16px;
  line-height: 20px;
  padding: 6px 16px;
  position: relative;
}
.modal-apply-application /deep/ .app-actions .btn:hover {
  text-decoration: none;
}
.modal-apply-application /deep/ .app-actions .btn.btn-app-cancel {
  background-color: rgb(255,255,255);
  border: 1px solid rgb(37,106,179);
  color: rgb(56,56,56);
}
.modal-apply-application /deep/ .app-actions .btn.btn-app-cancel:hover,
.modal-apply-application /deep/ .app-actions .btn-app-cancel.disabled {
  background-color: rgb(211,225,239);
}
.modal-apply-application /deep/ .app-actions .btn-app-cancel.disabled {
  border: 1px solid rgb(171,171,171);
  color: rgb(171,171,171);
}
.modal-apply-application /deep/ .app-actions .btn.btn-app-apply {
  background-color: rgb(37,106,179);
  color: rgb(255,255,255);
}
.modal-apply-application /deep/ .app-actions .btn.btn-app-apply:hover,
.modal-apply-application /deep/ .app-actions .btn-app-apply.disabled {
  background-color: rgb(25,73,124);
}
.modal-apply-application /deep/ .app-actions .btn-app-apply.disabled {
  border: 1px solid rgb(171,171,171);
  color: rgb(171,171,171);
}
.enroll-btn.reset-enroll-btn {
  height: initial;
  margin: initial;
}
.p-timezone {
  font-size: 12px !important;
  line-height: 14px !important;
}
@media (min-width: 576px) {
  .p-timezone {
    font-size: 16px !important;
    line-height: 20px !important;
  }
}
.has-manage-btn /deep/ .btn-path {
  border-color: rgb(37, 106, 179) !important;
  color: rgb(38, 50, 56) !important;
  box-shadow: none !important;
}

.btn-path.btn-block {
  width: 100% !important;
}
.div-is-path {
  color: rgb(120, 144, 156);
}
.row.is-path {}
.row.is-path /deep/ .col {
  text-align: center;
}
.row.is-path /deep/ .col div:first-child  {
  align-items: center;
  display: inline-grid;
  gap: 10px;
  grid-template-columns: 24px 1fr;
}
.row.is-path /deep/ .col div:first-child span  {
  font-size: 28px;
  line-height: 34px;
}
.row.is-path /deep/ .col div:last-child {
  font-size: 12px;
  line-height: 16px;
}

/**************************/
.main-paths-container {
    display: grid;
    gap: 20px;
    margin-bottom: 100px;
}
.paths-container {
    border: 1px solid rgb(227, 229, 232);
    border-radius: 4px;
    display: grid;
    /**grid-template-columns: 24px 1fr;
    gap: 26px;**/
}
.check-container {
    justify-self: center;
    align-items: center;
    display: grid;
}
.path-container {
    align-items: center;
    background-color: rgb(255, 255, 255);
    display: grid;
    grid-template-columns: 248px auto;
}
.path-image {
    background-size: cover;
    background-color:darkgray;
    background-size: cover;
    height: 112px;
    /*border-radius: 4px;*/
}
.path-info {
  display: grid;
  gap: 8px;
  padding: 16px 24px;
}
.path-info /deep/ .path-title {
  align-items: center;
  display: grid;
  grid-template-columns: 1fr auto;
}
.path-course-info {
    display: grid;
    /**grid-template-columns: 1fr auto;**/
    justify-content: end;
}
.path-courses-container {
    background-color: rgb(227, 229, 232);
    padding: 23px 25px;
    /*margin-left: 50px;*/
}
.course-container {
    background-color: rgb(255, 255, 255);
    display: grid;
    grid-template-columns: 178px auto;
    margin-bottom: 16px;
}
.course-image {
    height: 80px;
    background-size: cover;
    background-color: darkgray;
}
.course-info {
    padding: 8px 30px;
}
.course-title {
  align-items: center;
  color: rgb(37, 106, 179);
  display: grid !important;
  grid-template-columns: 1fr auto;
}
.btn-collapse {
    width: 480px;
}
.modal-footer {
    display: grid;
    background-color: rgba(var(--primaryColor));
    grid-template-columns: repeat(2,auto);
    justify-content: space-between;
    padding: 15px 30px;
    position: fixed;
    width: 100%;
    bottom: 0px;
}
.footer-select-message {
    display: grid;
    grid-template-columns: repeat(2,auto);
    align-items: center;
    color: rgb(255, 255, 255);
    gap: 15px;
    justify-content: space-evenly;
}

.footer-select-message h1,
.footer-select-message h4 {}
.footer-action /deep/ .btn.btn-link {
    color: rgb(255, 255, 255);
}
.btn-link.collapsed /deep/ .less-icon {
    display: none;
}
.btn-link:not(.collapsed) /deep/ .add-icon {
    display: none;
}
.btn-collapsed /deep/ span, .p-14 {
  font-size: 14px;
  line-height: 20px;
}
.certificate-container {
  border: 1px solid rgb(227, 229, 232);
  border-radius: 4px;
  display: grid;
  grid-template-columns: 120px 1fr;
}
.certificate-container /deep/ .certificate-image {
  background-color: rgb(207, 216, 220);
  height: 120px;
  width: 120px;
}
.certificate-container /deep/ .certificate-info {
  display: grid;
  padding: 16px 24px;
  gap: 40px;
}
.certificate-container /deep/ .certificate-info p {
  margin-bottom: 0px;
}
.certificate-container /deep/ .certificate-info .certificate-valid {
  color: rgb(211, 47, 47);
}
.coursemanagers-info {
  display: grid;
  grid-template-columns: 1fr 48px;
  gap: 10px;
}
.coursemanagers-info /deep/ p {
  font-size: 14px;
  margin-bottom: 0px;
}
.instructor-link {
  cursor: pointer;
}
.instructor-name {
  color: rgb(38, 50, 56);
  font-family: "Source Sans Pro";
  font-size: 24px;
  line-height: 34px;
}
</style>